import Vue from 'vue'
import _ from 'lodash'
import i18n from '../translation'
import _watcheebox from '../components/watcheebox/watcheebox.js'
import Push from 'push.js'
import { DOMAINE, AWSS3_STATIC } from '../constants'
import axios from 'axios'
import router from '@/router'
// import { error } from 'shelljs'
// import { _User } from './user.js'
let MAX_VISITORS = 300

export const _StoreWatcheeBox = {
  namespaced: true,

  state: {
    visiteursMap: {}, // { [visiteurID]: visiteur }
    status: 'offline',
    statusManually: '',
    isConnected: false,
    reconnexionSocket: false,
    socketMessage: '',
    mySocketID: '',
    socketStatus: true,
    demandeCobrowsing: {},
    cobrowsingActif: [false, false, false, false],
    timerActifAgent: [false, false, false, false],
    // roomName: '',
    focusPupitre: { view: '', focusSessionID: '', myFocus: true },
    agentsArray: [],
    listeAllVisiteurs: [],
    allDataVisiteurOpened: {},
    listeChatAgent: [],
    listeContactReseaux: [],
    lastMessage: {},
    newMessage: {},
    idAgentSelectedListe: false,
    statusMessage: {},
    // isTyping: {},
    clientSatisfaction: {},
    transfertStatusReception: {},
    transfertStatusEmission: {},
    sessionsPrivees: [],
    visiteurChatSelected: null,
    messageAttenteSelected: {},
    contactSelected: {},
    countVisitors: null,
    tooMuchAgentsChecked: false,
    multiSessionsAgent: false,
    sessionDejaActive: false,
    sessionPhpActive: null,
    delogOldSession: false,
    autoDelogMySession: false,
    pupitreViewStatus: 4,
    dragChat: false,
    sessionVisioconf: {confURL: false},
    sessionVisioVente: {confName: false, numContacts: 0, remoteStream: false},
    sessionWebcall: {confName: false, numContacts: 0, remoteStream: false, camera: false},
    webRTCOffer: null,
    webRTCAnswer: null,
    webRTCICECandidate: null,
    webRTCReponseScreensharing: null,
    webRTCCloseScreensharing: false,
    webRTCTokenTurnServer: null,
    reconnectTimer: null,
    isTryingReconnect: false
  },

  getters: {
    WATCHEEBOX_STATE: state => state,
    WATCHEEBOX_LISTE_VISITEURS: state => state.listeAllVisiteurs,

    // Construction du contenu du pupitre
    pupitreViewsData (state) {
      // console.log('pupitreViewsData', state.listeAllVisiteurs)
      let pupitre = [{view: {}}, {view: {}}, {view: {}}, {view: {}}]
      _.each(state.listeAllVisiteurs, function (o) {
        if (!_.isNil(o.placePupitre)) {
          // console.log('data visiteur', o)
          let placeIndex = (o.placePupitre - 1)
          let newObjectPupitre = {view: {
            visiteurDatas: o,
            visiteurID: o.visiteurID,
            viewStatus: true,
            online: o.status === 'online'
          }}

          pupitre.splice(placeIndex, 1, newObjectPupitre)
        }
      })
      // console.log('pupitre ', pupitre)
      return pupitre
    }
  },

  mutations: {
    INIT (state) {
      state.status = 'online'
      state.statusManually = ''
      state.isConnected = false
      state.reconnexionSocket = false
      state.socketMessage = ''
      state.mySocketID = ''
      state.socketStatus = true
      state.demandeCobrowsing = {}
      state.cobrowsingActif = [false, false, false, false]
      state.timerActifAgent = [false, false, false, false]
      // state.roomName = ''
      state.focusPupitre = { view: '', focusSessionID: '', myFocus: true }
      state.agentsArray = []
      state.listeAllVisiteurs = []
      state.allDataVisiteurOpened = {}
      state.listeChatAgent = []
      state.listeContactReseaux = []
      state.lastMessage = {}
      state.newMessage = {}
      state.idAgentSelectedListe = false
      state.statusMessage = {}
      state.isTyping = {}
      state.clientSatisfaction = {}
      state.transfertStatusReception = {}
      state.transfertStatusEmission = {}
      state.sessionsPrivees = []
      state.visiteurChatSelected = null
      state.messageAttenteSelected = {}
      state.contactSelected = {}
      state.countVisitors = null
      state.tooMuchAgentsChecked = false
      state.multiSessionsAgent = false
      state.sessionDejaActive = false
      state.sessionPhpActive = null
      state.delogOldSession = false
      state.autoDelogMySession = false
      // state.pupitreViewStatus = 4
      state.dragChat = false
      state.sessionVisioconf = {confURL: false}
      state.sessionVisioVente = {
        confName: false,
        muteMic: false,
        muteCam: false,
        numContacts: 0,
        sessionId: null,
        visiteurID: null,
        leaveConf: false,
        startConf: false,
        toggleStream: true,
        placePupitreVisio: 1,
        remoteStream: false,
        message: {
          text: 'Vous pouvez envoyer une invitation à votre internaute afin qu\'il puisse participer à votre visio vente.',
          color: 'info',
          icone: 'info'
        }
      }
      state.sessionWebcall = {
        confName: false,
        sessionId: null,
        visiteurID: null,
        visiteurSocketID: null,
        siteId: null,
        leaveConf: false,
        startConf: false,
        remoteStream: false,
        camera: false,
        action: ''
      }
      state.webRTCOffer = null
      state.webRTCAnswer = null
      state.webRTCICECandidate = null
      state.webRTCReponseScreensharing = null
      state.webRTCCloseScreensharing = false
      state.webRTCTokenTurnServer = null
    },

    START_RECONNECT_LOOP (state) {
      state.isTryingReconnect = true
    },
    STOP_RECONNECT_LOOP (state) {
      state.isTryingReconnect = false
      if (state.reconnectTimer) {
        clearInterval(state.reconnectTimer)
        state.reconnectTimer = null
      }
    },
    SET_RECONNECT_TIMER (state, timer) {
      state.reconnectTimer = timer
    },

    SET_SOCKET_ID (state, data) {
      console.log('SET_SOCKET_ID ', data)
      state.mySocketID = data
    },

    SET_CONNECTED (state, value) {
      state.isConnected = value
    },

    // -------------------------------------------------------------
    // -------------------------------------------------------------
    // VISIOVENTE
    // Tableau des data : state.sessionVisioVente
    // -------------------------------------------------------------
    // enregistre les infos de la visioconf en cours
    // -------------------------------------------------------------
    SET_SESSION_VISIOCONF (state, data) {
      console.log('SET_SESSION_VISIOCONF', data)
      state.sessionVisioconf = data
      // state.visioconfStatus = true
    },
    // -------------------------------------------------------------
    // efface les infos de la visioconf en cours
    // -------------------------------------------------------------
    DEL_SESSION_VISIOCONF (state) {
      console.log('DEL_SESSION_VISIOCONF')
      state.sessionVisioconf = {confURL: false}
      // state.visioconfStatus = false
    },

    // -------------------------------------------------------------
    // enregistre les infos de la visioconf en cours
    // -------------------------------------------------------------
    SET_SESSION_VISIOVENTE (state, data) {
      console.log('SET_SESSION_VISIOVENTE', data)
      // state.sessionVisioVente.placePupitreVisio = data.placePupitreVisio
      // state.sessionVisioVente.visiteurID = data.visiteurID
      state.sessionVisioVente = data
      // state.visioconfStatus = true
    },
    // -------------------------------------------------------------
    // modification des infos de la visioconf en cours
    // -------------------------------------------------------------
    CHANGE_SESSION_VISIOVENTE (state, data) {
      console.log('CHANGE_SESSION_VISIOVENTE', data)
      state.sessionVisioVente.placePupitreVisio = data.placePupitreVisio
      state.sessionVisioVente.visiteurID = data.visiteurID
      Object.entries(state.sessionVisioVente).forEach(([key, val]) => {
        if (key === data.name) {
          state.sessionVisioVente[key] = data.value
        }
        // console.log('key :', state.sessionVisioVente[key]) // the name of the current key.
        // console.log(val) // the value of the current key.
      })
    },
    // -------------------------------------------------------------
    // efface les infos de la visioconf en cours
    // -------------------------------------------------------------
    DEL_SESSION_VISIOVENTE (state) {
      console.log('DEL_SESSION_VISIOVENTE')
      state.sessionVisioVente = {
        confName: false,
        muteMic: false,
        muteCam: false,
        numContacts: 0,
        sessionId: null,
        visiteurID: null,
        leaveConf: false,
        startConf: false,
        toggleStream: true,
        placePupitreVisio: 1,
        remoteStream: false,
        message: {
          text: 'Vous pouvez envoyer une invitation à votre internaute afin qu\'il puisse participer à votre visio vente.',
          color: 'info',
          icone: 'info'
        }
      }
      // state.visioconfStatus = false
    },
    // -------------------------------------------------------------
    // ferme la local stream de visioVente
    // -------------------------------------------------------------
    MESSAGES_SYSTEM_VISIOVENTE (state, data) {
      console.log('MESSAGES_SYSTEM_VISIOVENTE', data)
      Object.entries(state.sessionVisioVente).forEach(([key, val]) => {
        if (key === data.name) {
          state.sessionVisioVente[key] = data.value
        }
      })
    },
    // !!!!! plus utils pour le moment !!!!!
    // -------------------------------------------------------------
    // ferme la local stream de visioVente
    // -------------------------------------------------------------
    RELEASE_LOCALSTREAM_VISIOVENTE (state) {
      if (state.sessionVisioVente.localStream !== 'null') {
        console.log('RELEASE_LOCALSTREAM_VISIOVENTE')
        state.sessionVisioVente.localStream.release()
      }
    },

    // -------------------------------------------------------------
    // quitte la session de visioVente
    // -------------------------------------------------------------
    LEAVE_SESSION_VISIOVENTE (state) {
      if (state.sessionVisioVente.localStream !== 'null') {
        console.log('LEAVE_SESSION_VISIOVENTE')
        state.sessionVisioVente.connectedConversation.leave()
      }
    },

    // -------------------------------------------------------------
    // detruit la session de visioVente
    // -------------------------------------------------------------
    DESTROY_SESSION_VISIOVENTE (state) {
      console.log('DESTROY_SESSION_VISIOVENTE')
      state.sessionVisioVente.connectedConversation.destroy()
    },
    // !!!!!  !!!!!

    // -------------------------------------------------------------
    // efface le userAgent de visioVente
    // -------------------------------------------------------------
    DEL_USERAGENT_VISIOVENTE (state) {
      console.log('DEL_USERAGENT_VISIOVENTE')
    },
    // -------------------------------------------------------------
    // -------------------------------------------------------------

    // -------------------------------------------------------------
    // -------------------------------------------------------------
    // WEBCALL
    // Tableau des data : state.sessionWebcall
    // -------------------------------------------------------------
    // efface les infos du webcall en cours
    // -------------------------------------------------------------
    DEL_SESSION_WEBCALL (state) {
      console.log('DEL_SESSION_WEBCALL')
      state.sessionWebcall = {
        confName: false,
        sessionId: null,
        visiteurID: null,
        visiteurSocketID: null,
        siteId: null,
        leaveConf: false,
        startConf: false,
        remoteStream: false,
        camera: false,
        action: ''
      }
    },
    // -------------------------------------------------------------
    // efface le userAgent de visioVente
    // -------------------------------------------------------------
    CHANGE_SESSION_WEBCALL (state, data) {
      console.log('CHANGE_SESSION_WEBCALL')
      state.sessionWebcall.visiteurID = data.visiteurID
      Object.entries(state.sessionWebcall).forEach(([key, val]) => {
        Object.entries(data.changeVal).forEach(([i, value]) => {
          if (key === i) {
            state.sessionWebcall[key] = value
          }
        })
        // console.log('key :', state.sessionWebcall[key]) // the name of the current key.
        // console.log(val) // the value of the current key.
      })
    },
    // -----------------------------------------------------------------
    // Son webcall appel entrant
    // -----------------------------------------------------------------
    /*
    PLAY_SOUND_WEBCALL () {
      let audioWebcall = document.createElement('audio')
      audioWebcall.id = 'webcallAudio'
      audioWebcall.setAttribute(
        'src',
        AWSS3_STATIC + '/sounds/sonnerieTel.mp3'
      )
      audioWebcall.loop = true
      audioWebcall.load()
      audioWebcall.play()
    },
    STOP_SOUND_WEBCALL () {
      let audioWebcall = document.getElementById('webcallAudio')
      audioWebcall.pause()
    },
    */
    // -------------------------------------------------------------
    // -------------------------------------------------------------

    // -----------------------------------------------------------------
    // Son nouvelle conversation
    // -----------------------------------------------------------------
    PLAY_SOUND_CONVERSATION () {
      let audioConversation = document.createElement('audio')
      audioConversation.setAttribute(
        'src',
        AWSS3_STATIC + '/sounds/new_conv1.mp3'
      )
      audioConversation.load()
      audioConversation.play()
    },
    PLAY_SOUND_CONVERSATION2 () {
      let audioConversation = document.createElement('audio')
      audioConversation.setAttribute(
        'src',
        AWSS3_STATIC + '/sounds/new_conv2.mp3'
      )
      audioConversation.load()
      audioConversation.play()
    },

    // -----------------------------------------------------------------
    // Son nouveau message et focus sur le visiteur
    // -----------------------------------------------------------------
    PLAY_SOUND_MESSAGE_FOCUS_IN () {
      let audioMessageFocusIn = document.createElement('audio')
      audioMessageFocusIn.setAttribute(
        'src',
        AWSS3_STATIC + '/sounds/new_message1.mp3'
      )
      audioMessageFocusIn.load()
      audioMessageFocusIn.play()
    },

    // -----------------------------------------------------------------
    // Son nouveau message et pas focus sur le visiteur
    // -----------------------------------------------------------------
    PLAY_SOUND_MESSAGE_FOCUS_OUT () {
      let audioMessageFocusOut = document.createElement('audio')
      audioMessageFocusOut.setAttribute(
        'src',
        AWSS3_STATIC + '/sounds/new_message2.mp3'
      )
      audioMessageFocusOut.load()
      audioMessageFocusOut.play()
    },
    PLAY_SOUND_MESSAGE_FOCUS_OUT2 () {
      let audioMessageFocusOut = document.createElement('audio')
      audioMessageFocusOut.setAttribute(
        'src',
        AWSS3_STATIC + '/sounds/new_message4.mp3'
      )
      audioMessageFocusOut.load()
      audioMessageFocusOut.play()
    },

    // -----------------------------------------------------------------
    // Son nouveau message et pas focus sur le visiteur
    // -----------------------------------------------------------------
    PLAY_SOUND_OPEN_BO () {
      let audioOuvertureBO = new Audio(AWSS3_STATIC + '/sounds/ouverture1.mp3')
      // let audioOuvertureBO = document.createElement('audio')
      // audioOuvertureBO.setAttribute(
      //   'src',
      //   AWSS3_STATIC + '/sounds/ouverture1.mp3'
      // )
      // audioOuvertureBO.load()
      // audioOuvertureBO.stop()
      // audioOuvertureBO.play()
      // console.log('audio', audioOuvertureBO)
      audioOuvertureBO.load()
      audioOuvertureBO.volume = 1
      let playPromise = audioOuvertureBO.play()

      if (playPromise !== undefined) {
        playPromise.then(() => {
          audioOuvertureBO.play()
        }).catch((e) => {
          console.log('erreur', e)
        })
      }
      // audioOuvertureBO.play()
    },

    // -----------------------------------------------------------------
    // Son nouveau message et pas focus sur le visiteur
    // -----------------------------------------------------------------
    PLAY_SOUND_OFFLINE () {
      let audioOffline = document.createElement('audio')
      audioOffline.setAttribute(
        'src',
        AWSS3_STATIC + '/sounds/offline.mp3'
      )
      audioOffline.load()
      audioOffline.play()
    },

    // -----------------------------------------------------------------
    // Mutations CHATS
    // -----------------------------------------------------------------
    SOCKET_CONNECT_CLIENT (state) {
      console.log('SOCKET_CONNECT_CLIENT', state.statusManually)
      console.log('connect client server')
      state.isConnected = true
      state.status = state.statusManually ? state.statusManually : 'offline' // par defaut offline
      state.reconnexionSocket = false // pas besoin de tenter une reconnexion je suis connecté
    },

    SOCKET_DISCONNECT_CLIENT (state) {
      console.log('SOCKET_DISCONNECT_CLIENT')
      state.isConnected = false
      state.socketStatus = false
      state.status = 'offline' // deconnexion donc offline
      // on va tenter une reconnexion au socket au cas ou le serveur soit tombé
      state.reconnexionSocket = true
      this.commit('_StoreWatcheeBox/PLAY_SOUND_OFFLINE') // son deconnexion
    },

    SOCKET_CONNECTING (state, message) {
      console.log('SOCKET_CONNECTING', message)
      if (message !== undefined) {
        state.socketStatus = true
      } else {
        state.socketStatus = false
      }
      console.log('state.socketStatus :' + state.socketStatus)
    },

    SOCKET_CONNECT_FAILED (state, message) {
      console.log('SOCKET_CONNECT_FAILED')
      state.socketStatus = false
      console.log('connect_failed :' + message)
    },

    SOCKET_CLOSE (state, message) {
      console.log('SOCKET_CLOSE')
      state.socketStatus = false
      console.log('close :' + message)
    },

    SOCKET_RECONNECT (state, message) {
      console.log('SOCKET_RECONNECT')
      state.socketStatus = true
      console.log('reconnect : ' + message + ' - ')
    },

    SOCKET_RECONNECTING (state, message) {
      console.log('SOCKET_RECONNECTING')
      state.socketStatus = true
      state.reconnexionSocket = true
      console.log('reconnecting : ' + message + ' - ')
      // a chaque tentative de reconnexion je test si un nouveau node est dispo
      // rechargeLoadBalancer();
    },

    SOCKET_RECONNECT_FAILED (state, message) {
      console.log('reconnect_failed -- connection :' + message)
    },

    SOCKET_RECONNECT_ATTEMPT (state, message) {
      state.socketStatus = false
      console.log('reconnect_attempt :' + message)
    },

    SOCKET_LAST_SOCKET_DISCONNECTED (state, message) {
      console.log('lastSocketDisconnected :' + message)
    },

    SOCKET_ERROR_MESSAGE (state, message) {
      console.log('SOCKET_ERROR_MESSAGE', message)
      state.socketMessage = message
    },

    // si redis retourne un socket.id different du mien
    SOCKET_NO_AUTORISATION_AGENT (state, message) {
      console.log('SOCKET_NO_AUTORISATION_AGENT', message)
      state.sessionDejaActive = true
      state.sessionPhpActive = message.PHPSessionID
    },
    // si c'est une multiple connexion d'un agent sur le même navigateur
    MULTICONNEXIONS_AGENT (state, message) {
      console.log('MULTICONNEXIONS_AGENT', message)
      state.multiSessionsAgent = true
      state.sessionPhpActive = message.PHPSessionID
    },

    // -------------------------------------------------------------
    //  efface les données multisession à la fermeture de la fenetre
    // -------------------------------------------------------------
    CLOSE_MULTISESSION_AGENT (state) {
      console.log('CLOSE_MULTISESSION_AGENT')
      state.sessionDejaActive = false
      state.multiSessionsAgent = false
    },

    // check si la session php n'est pas la même
    // c'est peut-etre une connexion distante
    // SOCKET_CHECK_SESSIONPHP (state, message) {
    //   console.log('SOCKET_CHECK_SESSIONPHP', message)
    //   state.sessionDejaActive = false
    //   state.sessionPhpActive = message.PHPSessionID
    // },

    SOCKET_DELOG_OLD_SESSION (state, message) {
      console.log('SOCKET_DELOG_OLD_SESSION', message)
      state.delogOldSession = true
    },

    SOCKET_AUTO_DELOG_SESSION (state, message) {
      console.log('SOCKET_AUTO_DELOG_SESSION', message)
      state.autoDelogMySession = true
    },

    SOCKET_INFOS_AGENT (state, message) {
      console.log('SOCKET_INFOS_AGENT')
      // state.roomName = message.roomName
      state.mySocketID = message.mySocketID
      state.sessionDejaActive = false
      state.multiSessionsAgent = false
      state.sessionPhpActive = null
      state.isConnected = true
      state.delogOldSession = false
      state.autoDelogMySession = false
      // check si l'agent est dispo en comparant le nombre'chatMax' et ses sessions chat en cours
      if (this.getters['_User/user'].chatsMax <= state.sessionsPrivees.length) {
        state.status = 'busy'
      }
      // console.log('SOCKET_INFOS_AGENT state', state)
    },

    SOCKET_LISTE_AGENTS (state, message) {
      state.status = message.status
      state.agentsArray = message.listeAgents
      state.listeChatAgent = message.chatAgent
    },

    RECONNEXION_AUTO (state, message) {
      console.log('state.reconnexionSocket', state.reconnexionSocket)
      state.reconnexionSocket = message.status
    },

    // -------------------------------------------------------------------------------------------
    // l'agent drag&drop un chat
    // -------------------------------------------------------------------------------------------
    CHANGE_DRAG_CHAT (state, message) {
      state.dragChat = message
    },

    // -------------------------------------------------------------------------------------------
    // L'agent change la vue de son pupitre
    // -------------------------------------------------------------------------------------------
    CHANGE_VIEW_PUPITRE (state, message) {
      // console.log('CHANGE_VIEW_PUPITRE', message)
      state.pupitreViewStatus = message
    },

    // -------------------------------------------------------------------------------------------
    // L'agent change le visiteur de slot pupitre
    // -------------------------------------------------------------------------------------------
    CHANGE_PLACE_PUPITRE_VISITEUR (state, message) {
      // console.log('CHANGE_PLACE_PUPITRE_VISITEUR', message)
      let dateChange = Date.now()
      // recherche le bon visiteur
      var indexDrop = _.findIndex(state.listeAllVisiteurs, {visiteurID: message.dataDrop.visiteurID})
      if (indexDrop === -1) return
      // si la vue est occupée
      if (message.statusView) {
        // regarde qui occupe cete place
        var indexPlaceOccupe = _.findIndex(state.listeAllVisiteurs, {visiteurID: message.idVisiteurPlace})
        // Si cette place est deja occupé
        if (indexPlaceOccupe !== -1) {
          // on change la place du visiteur sur le pupitre par la place du visiteur dropé
          // clone le visteur deja en place
          var visiteurDejaLa = _.cloneDeep(state.listeAllVisiteurs[indexPlaceOccupe])
          // console.log('place visiteur deja la', visiteurDejaLa.placePupitre)
          // ----------------------------------------------------------------
          // enregistre dans la table la fermeture du chat deja en place
          let dataToPost = new window.FormData()
          dataToPost.append('timestamp', dateChange)
          dataToPost.append('agent_id', this.getters['_User/user'].id)
          dataToPost.append('visiteur_id', visiteurDejaLa.visiteurID)
          dataToPost.append('placePupitre', visiteurDejaLa.placePupitre)
          dataToPost.append('status', 0)
          dataToPost.append('numChat', state.sessionsPrivees.length)
          dataToPost.append('chatMax', this.getters['_User/user'].chatsMax)
          axios.post('post/addChatPupitre.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
          .then(response => {
            // console.log('chat in pupitre', response)
          })

          // ----------------------------------------------------------------
          // puis enregistre dans la table l'ouverture du chat dans sa nouvelle place
          let dataToPost2 = new window.FormData()
          dataToPost2.append('timestamp', dateChange)
          dataToPost2.append('agent_id', this.getters['_User/user'].id)
          dataToPost2.append('visiteur_id', visiteurDejaLa.visiteurID)
          dataToPost2.append('placePupitre', message.dataDrop.placePupitreActif)
          dataToPost2.append('status', 1)
          dataToPost2.append('numChat', state.sessionsPrivees.length)
          dataToPost2.append('chatMax', this.getters['_User/user'].chatsMax)
          axios.post('post/addChatPupitre.php', dataToPost2, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
          .then(response => {
            // console.log('chat in pupitre', response)
          })
          // change la place
          visiteurDejaLa.placePupitre = message.dataDrop.placePupitreActif
          visiteurDejaLa.lastMessage = '' // on efface son dernier message pour ne pas l'affiche dans la liste d'attente (car déjà lu)
          // remet le visiteur modifié dans la liste
          state.listeAllVisiteurs.splice(indexPlaceOccupe, 1, visiteurDejaLa)
          // console.log('new place visiteur deja la', message.dataDrop.placePupitreActif)
        } else {
          console.log('aucun visiteur actuellemnt en place', message.place)
        }
      }

      console.log('old place', message.dataDrop.placePupitreActif)
      console.log('new place', message.place)
      // ----------------------------------------------------------------
      // enregistre dans la table la fermeture du chatqui change de place
      let dataToPost = new window.FormData()
      dataToPost.append('timestamp', dateChange)
      dataToPost.append('agent_id', this.getters['_User/user'].id)
      dataToPost.append('visiteur_id', message.dataDrop.visiteurID)
      dataToPost.append('placePupitre', message.dataDrop.placePupitreActif)
      dataToPost.append('status', 0)
      dataToPost.append('numChat', state.sessionsPrivees.length)
      dataToPost.append('chatMax', this.getters['_User/user'].chatsMax)
      axios.post('post/addChatPupitre.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        console.log('chat in pupitre', response)
      })
      // ----------------------------------------------------------------
      // ouis enregistre dans la table l'ouverture dans sa nouvelle place
      let dataToPost2 = new window.FormData()
      dataToPost2.append('timestamp', dateChange)
      dataToPost2.append('agent_id', this.getters['_User/user'].id)
      dataToPost2.append('visiteur_id', message.dataDrop.visiteurID)
      dataToPost2.append('placePupitre', message.place)
      dataToPost2.append('status', 1)
      dataToPost2.append('numChat', state.sessionsPrivees.length)
      dataToPost2.append('chatMax', this.getters['_User/user'].chatsMax)
      axios.post('post/addChatPupitre.php', dataToPost2, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        console.log('chat in pupitre', response)
      })

      // sinon on change juste la place du visiteur dropé
      // clone le visteur
      var visiteurSelect = _.cloneDeep(state.listeAllVisiteurs[indexDrop])
      // change ca place
      visiteurSelect.placePupitre = message.place
      // remet le visiteur modifié dans la liste
      state.listeAllVisiteurs.splice(indexDrop, 1, visiteurSelect)
    },

    // -------------------------------------------------------------------------------------------
    // L'agent à rechargé le BO, j'efface le nouveau message enregistré
    // -------------------------------------------------------------------------------------------
    AGENT_RELOAD (state, message) {
      state.newMessage = {}
    },

    // -------------------------------------------------------------------------------------------
    // pour savoir avec qui l'agent discute sur le pupitre
    // -------------------------------------------------------------------------------------------
    AGENT_FOCUS (state, message) {
      var newFocusData = _.cloneDeep(state.focusPupitre) // clone le state focus
      if (message.view) {
        newFocusData.view = message.view
      }
      if (message.visiteurID) {
        newFocusData.focusSessionID = message.visiteurID
      }
      if (!_.isNil(message.myFocus)) {
        newFocusData.myFocus = message.myFocus
      }
      // state.focusPupitre = newFocusData
    },

    // -------------------------------------------------------------------------------------------
    // reponse du peer distant
    // -------------------------------------------------------------------------------------------
    SOCKET_TOKEN_TURN_SERVER (state, message) {
      console.log('SOCKET_TOKEN_TURN_SERVER', message)
      state.webRTCTokenTurnServer = message.token
    },
    // -------------------------------------------------------------------------------------------
    // reponse du peer distant
    // -------------------------------------------------------------------------------------------
    SOCKET_PEER_OFFER (state, message) {
      console.log('SOCKET_PEER_OFFER', message)
      state.webRTCOffer = message.sdp
    },
    // -------------------------------------------------------------------------------------------
    // reponse du peer distant
    // -------------------------------------------------------------------------------------------
    SOCKET_PEER_ANSWER (state, message) {
      console.log('SOCKET_PEER_ANSWER', message)
      state.webRTCAnswer = message.sdp
    },
    // -------------------------------------------------------------------------------------------
    // reponse du peer distant
    // -------------------------------------------------------------------------------------------
    SOCKET_ICE_CANDIDATE (state, message) {
      console.log('SOCKET_ICE_CANDIDATE', message)
      state.webRTCICECandidate = message.data
    },
    // -------------------------------------------------------------------------------------------
    // reponse de la demande de screensharing en webrtc
    // -------------------------------------------------------------------------------------------
    SOCKET_WEBRTC_REPONSE_SCREENSHARING (state, message) {
      console.log('SOCKET_WEBRTC_REPONSE_SCREENSHARING', message)
      state.webRTCReponseScreensharing = message.data
    },
    // -------------------------------------------------------------------------------------------
    // le client coupe le screensharing en webrtc
    // -------------------------------------------------------------------------------------------
    SOCKET_WEBRTC_CLOSE_SCREENSHARING (state, message) {
      console.log('SOCKET_WEBRTC_CLOSE_SCREENSHARING', message)
      state.webRTCCloseScreensharing = true
    },

    // -------------------------------------------------------------------------------------------
    // Demande de webcall
    // -------------------------------------------------------------------------------------------
    SOCKET_DEMANDE_WEBCALL (state, message) {
      console.log('SOCKET_DEMANDE_WEBCALL', message)
      // impossible d'ajouter une demande de webcal si l'ancien webcall n'est pas totalement fermé
      // ou qu'il y a deja une demande en cours
      if (state.sessionWebcall.visiteurID === null || state.sessionWebcall.action === 'rejetAppel') {
        state.sessionWebcall.confName = 'conf_' + message.data.chatSession
        state.sessionWebcall.visiteurID = message.data.chatSession
        state.sessionWebcall.visiteurSocketID = message.data.mySocketID
        state.sessionWebcall.siteId = message.data.siteId
        state.sessionWebcall.sessionId = message.data.chatSession
        state.sessionWebcall.action = message.action
        state.sessionWebcall.camera = message.data.webcallVideo
        // state.webRTCCloseScreensharing = true
        // 'cibleSocketID': agentSelected,
        // 'WZAgentId': WatcheezyIDAgentSelected,
        // 'entrepriseId': entrepriseId,
        // 'timestamp': Date.now(),
        // 'entrepriseKey': wek
      }
    },
    // -------------------------------------------------------------------------------------------
    // close webCall
    // -------------------------------------------------------------------------------------------
    SOCKET_CLOSE_WEBCALL (state, message) {
      console.log('SOCKET_CLOSE_WEBCALL', message)
      // s'applique uniquement à la visio en cours avec ce visiteur
      if (message.data.chatSession === state.sessionWebcall.visiteurID) {
        if (state.sessionWebcall.action === 'rejetAppel') {
          // state.sessionWebcall = {
          //   confName: false,
          //   sessionId: null,
          //   visiteurID: null,
          //   visiteurSocketID: null,
          //   siteId: null,
          //   leaveConf: false,
          //   startConf: false,
          //   remoteStream: false,
          //   camera: false,
          //   action: ''
          // }
        } else {
          state.sessionWebcall.action = message.action
        }
      }
      // state.webRTCCloseScreensharing = true
    },

    // -------------------------------------------------------------
    // efface les infos de la visioconf webrtc
    // -------------------------------------------------------------
    DEL_SESSION_WEBRTC (state) {
      console.log('DEL_SESSION_WEBRTC')
      state.webRTCOffer = null
      state.webRTCAnswer = null
      state.webRTCICECandidate = null
      state.webRTCReponseScreensharing = null
      state.webRTCCloseScreensharing = false
    },
    // -------------------------------------------------------------
    // efface ice candidate
    // -------------------------------------------------------------
    DEL_ICE_WEBRTC (state) {
      console.log('DEL_ICE_WEBRTC')
      state.webRTCICECandidate = null
    },

    // -------------------------------------------------------------------------------------------
    // mise a jour de la liste visiteurs du store avec celle venant du serveur nodejs
    // action de l'agent
    // message = liste des visiteur retourné par nodejs
    // 0 : status visiteur (offline/online)
    // 1 : langue du visiteur (FR.US...)
    // 2 : id du visteur (ex. 123_123456789)
    // 3 : ls room name
    // 4 : le socketID du visiteur
    // 5 : le site id
    // 6 : le nombre de notifications du visiteur
    // 6 : la place du visiteur sur le pupitre (corespond a l'index du tableau "pupitreViewsData" dans chatting.vue)
    // -------------------------------------------------------------------------------------------
    SOCKET_LISTE_VISITEURS (state, message) {
      console.log('SOCKET_LISTE_VISITEURS', state)
      let forFiltrageFront = false
      if (this.getters['_User/user'].filterFront === '1') {
        // console.log('filtage en front')
        forFiltrageFront = true
      } else {
        // console.log('pas de filtage en front')
        forFiltrageFront = false
      }
      // console.log('forFiltrageFront :', forFiltrageFront)
      // on commence par transformer le tableau en object
      let newArrayVisiteurs = []
      // console.log('SOCKET_LISTE_VISITEURS message.listeVisiteurs', message.listeVisiteurs)
      // on recherche dans la liste visiteur que nous retourne le serveur
      _.forEach(message.listeVisiteurs, function (visiteurListNode, key) {
        // console.log('SOCKET_LISTE_VISITEURS visiteurListNode', visiteurListNode)
        // filtre les uniquement les visiteurs de cet agent
        // grace au tableau des cles de licences visiteur
        if (_.indexOf(message.listAllSiteID, visiteurListNode.siteId) !== -1) {
          // console.log('site id trouvé : ', _.indexOf(message.listAllSiteID, visiteurListNode.siteId))
          // pour chaque visiteur on créer un object
          let newObjVisiteur = {
            status: visiteurListNode.etat,
            connexion: true,
            openFiche: false,
            lang: visiteurListNode.lang,
            visiteurID: visiteurListNode.id,
            roomName: visiteurListNode.roomName,
            socketID: [visiteurListNode.socketID],
            siteID: visiteurListNode.siteId,
            notification: visiteurListNode.notification,
            placePupitre: null,
            fileAttente: null,
            lastMessage: null,
            newMessage: false,
            timeStampArrive: null,
            reponseCobrowsing: false,
            motif: false,
            geoloc: {},
            histoChat: []
          }
          // si filtrage en front on ajoute ces valeurs
          if (forFiltrageFront) {
            newObjVisiteur['visiteurName'] = visiteurListNode.shortdesc
            newObjVisiteur['alreadyConsulted'] = visiteurListNode.alreadyConsulted
            newObjVisiteur['autoInvit'] = visiteurListNode.autoInvit
            newObjVisiteur['autoInvitType'] = visiteurListNode.autoInvitType
            newObjVisiteur['autoinvitSend'] = visiteurListNode.autoinvitSend
            newObjVisiteur['dateLastChat'] = visiteurListNode.dateLastChat
            newObjVisiteur['getplusinfoavailable'] = visiteurListNode.getplusinfoavailable
            newObjVisiteur['key'] = visiteurListNode.key
            newObjVisiteur['keyVis'] = visiteurListNode.keyVis
            newObjVisiteur['listAlert'] = visiteurListNode.listAlert
            newObjVisiteur['nbCustomAlert'] = visiteurListNode.nbCustomAlert
            newObjVisiteur['nb_alert'] = visiteurListNode.nb_alert
            newObjVisiteur['nbchats'] = visiteurListNode.nbchats
            newObjVisiteur['pagesFocus'] = visiteurListNode.pagesFocus
            newObjVisiteur['ponderation'] = visiteurListNode.ponderation
            newObjVisiteur['savedConversation'] = visiteurListNode.savedConversation
            newObjVisiteur['shortdesc'] = visiteurListNode.shortdesc
            newObjVisiteur['visId'] = visiteurListNode.visId
            newObjVisiteur['visitorApiInfo'] = visiteurListNode.visitorApiInfo
            newObjVisiteur['wz_textSocialNotif'] = visiteurListNode.wz_textSocialNotif
            // console.log('find newObjVisiteur', newObjVisiteur)
          }
          // console.log('newObjVisiteur', newObjVisiteur)
          // console.log('push visiteur', newObjVisiteur)
          newArrayVisiteurs.push(newObjVisiteur)
        }
        console.log('SOCKET_LISTE_VISITEURS : newArrayVisiteurs', newArrayVisiteurs)
      })

      // on recherche dans le store visiteurs
      _.forEach(state.listeAllVisiteurs, function (visiteurList, key) {
        // console.log('visiteurList', visiteurList)
        // je rajoute les visiteur qui sont deconnecté mais qui etaient dans le pupitre
        // ou les visiteur facebook en chat
        // pour ne pas prendre une place sur le pupitre par un visiteur plus connecté
        // il faut continuer à l'afficher pour que l'agent puisse fermer correctement la conversation
        if (
          visiteurList &&
          visiteurList.socketID === 0 &&
          (visiteurList.placePupitre !== null ||
            visiteurList.fileAttente !== null)
        ) {
          // console.log('visteurList socket 0')
          var index = _.findIndex(newArrayVisiteurs, {
            visiteurID: visiteurList.visiteurID
          })
          if (index !== -1) {
            newArrayVisiteurs[index].fileAttente = visiteurList.fileAttente // l'id de l'agent pour le remettre dans la bonne file
            newArrayVisiteurs[index].lastMessage = visiteurList.lastMessage // sont dernier message
          } else {
            newArrayVisiteurs.push(visiteurList) // ajoute le visiteur plus la dans la listeAllVisiteur
          }
        } else if (
          visiteurList &&
          visiteurList.network &&
          (visiteurList.placePupitre !== null ||
            visiteurList.fileAttente !== null)
        ) {
          // console.log('visteurList a un socket ')
          var index2 = _.findIndex(newArrayVisiteurs, {
            visiteurID: visiteurList.visiteurID
          })
          if (index2 !== -1) {
            newArrayVisiteurs[index2].fileAttente = visiteurList.fileAttente // l'id de l'agent pour le remettre dans la bonne file
            newArrayVisiteurs[index2].lastMessage = visiteurList.lastMessage // sont dernier message
          } else {
            newArrayVisiteurs.push(visiteurList) // ajoute le visiteur plus la dans la listeAllVisiteur
          }
        } else {
          // console.log('visteurList le reste')
          // on recherche dans la liste visiteur que nous retourne le serveur
          _.forEach(newArrayVisiteurs, function (visiteurArray, key) {
            // console.log('visiteur deja la', visiteurArray)
            // si le visiteur est déjà dans le store visiteur
            if (visiteurList && visiteurList.visiteurID === visiteurArray.visiteurID) {
              // on regarde si il est deja un histoChat
              if (visiteurList.histoChat.length) {
                visiteurArray.histoChat = visiteurList.histoChat // ajoute l'histoChat'
              }
              // on regarde si il est deja geolocalisé
              if (visiteurList.geoloc) {
                visiteurArray.geoloc = visiteurList.geoloc // ajoute la geoloc
              }
              // on regarde si il est deja en place sur le pupitre
              if (visiteurList.placePupitre) {
                // console.log('visiteurList.placePupitre', visiteurList.placePupitre)
                visiteurArray.placePupitre = visiteurList.placePupitre // ajoute la place dans le tableau du visiteur
              }
              // on regarde si il a deja une date d'arrivé dans le chat'
              if (visiteurList.timeStampArrive) {
                // console.log('visiteurList.placePupitre', visiteurList.placePupitre)
                visiteurArray.timeStampArrive = visiteurList.timeStampArrive // ajoute le timestamp dans le tableau du visiteur
              }
              // si c'est le visiteur avec sa fiche ouverte
              if (visiteurList.visiteurID === state.visiteurChatSelected) {
                // indique que csa fiche deja ouverte
                visiteurArray.openFiche = true
              }
              visiteurArray.menuSelected = visiteurList.menuSelected // garde ledernier menuselectionné
              visiteurArray.reponseCobrowsing = visiteurList.reponseCobrowsing // garde ledernier menuselectionné
              visiteurArray.alertsAllowed = visiteurList.alertsAllowed // garde la derniere valeur
              visiteurArray.newMessage = visiteurList.newMessage // sont premier message
              visiteurArray.lastMessage = visiteurList.lastMessage // sont dernier message
              // on regarde si il est deja en file d'attente
              if (visiteurList.fileAttente) {
                // ajoute les infos de la liste d'attente
                visiteurArray.fileAttente = visiteurList.fileAttente // l'id de l'agent pour le remettre dans la bonne file
                // visiteurArray.newMessage = visiteurList.newMessage // sont premier message
                // visiteurArray.timeStampArrive = visiteurList.timeStampArrive // sont heure d'arrive dans la file D'attente
              }
            }
          })
        }
      })
      console.log('newArrayVisiteurs fin', newArrayVisiteurs)
      state.listeAllVisiteurs = newArrayVisiteurs
    },

    SOCKET_LEAVE_VISITEURS (state, message) {
      var index = _.findIndex(state.listeAllVisiteurs, {
        visiteurID: message.clientID
      })
      if (index === -1) return
      var visiteurSelect = _.cloneDeep(state.listeAllVisiteurs[index])
      // si filtrage en front
      if (this.getters['_User/user'].filterFront === '1') {
        // si visiteur en chat
        if (visiteurSelect.placePupitre || visiteurSelect.openFiche) {
          visiteurSelect.connexion = false
          visiteurSelect.socketID = message.newSocketID
          state.listeAllVisiteurs.splice(index, 1, visiteurSelect) // modification des données visiteur
        } else {
          state.listeAllVisiteurs.splice(index, 1) // retire le visiteur
        }
      } else {
        visiteurSelect.connexion = false
        visiteurSelect.socketID = message.newSocketID
        state.listeAllVisiteurs.splice(index, 1, visiteurSelect) // modification des données visiteur
      }
    },

    SOCKET_CLIENT_CHANGE_SOCKETID (state, message) {
      // il faut refaire le tableau completement pour qu'il soit pris en compte par le mutation
      var index = _.findIndex(state.listeAllVisiteurs, {
        visiteurID: message.clientID
      })
      if (index === -1) return
      var visiteurSelect = _.cloneDeep(state.listeAllVisiteurs[index])
      visiteurSelect.status = 'online'
      visiteurSelect.connexion = true
      visiteurSelect.socketID = message.listeSocketID
      state.listeAllVisiteurs.splice(index, 1, visiteurSelect)
      // il aussi changer le socketID dans "sessionsPrivees"
      _.forEach(state.sessionsPrivees, (chatSession, key) => {
        if (chatSession[1] === message.clientID) {
          var chatSelect = _.cloneDeep(chatSession)
          chatSelect[0] = message.listeSocketID
          state.sessionsPrivees.splice(key, 1, chatSelect)
        }
      })
    },

    SOCKET_NEW_VISITEUR (state, message) {
      // console.log('message  ', message)
      let forFiltrageFront = false
      if (this.getters['_User/user'].filterFront === '1') {
        // console.log('filtage en front')
        forFiltrageFront = true
      } else {
        // console.log('pas de filtage en front')
        forFiltrageFront = false
      }
      // avant d'ajouter ce visiteur
      // il faut regarder si il peut etre presenté à cet agent
      // grace au tableau des siteID agent et du siteID visiteur
      if (_.indexOf(message.listAllSiteID, message.newVisiteur[5]) !== -1) {
        // pour l'object visiteurs
        var index = _.findIndex(state.listeAllVisiteurs, {
          visiteurID: message.newVisiteur[2]
        })
        if (message.maxVisitors) {
          MAX_VISITORS = message.maxVisitors
        }
        // console.log('shortdesc', _.isString(message.dataFiltrage.shortdesc))
        let shortdescNumConvert = _.toNumber(message.dataFiltrage.shortdesc) // converti le shortdesk en number
        // shortdescNumConvert retourne 'NaN' si pas un number
        // console.log(shortdescNumConvert + '  num', _.isNaN(shortdescNumConvert))
        if (index === -1 && (state.listeAllVisiteurs.length < MAX_VISITORS || _.isNaN(shortdescNumConvert))) {
          // si ce visiteur n'existe pas dans la liste
          var newObjVisiteur = {
            status: message.newVisiteur[0],
            connexion: true,
            openFiche: false,
            lang: message.newVisiteur[1],
            visiteurID: message.newVisiteur[2],
            roomName: message.newVisiteur[3],
            socketID: message.listeSocketID,
            siteID: message.newVisiteur[5],
            notification: message.newVisiteur[6],
            placePupitre: null,
            fileAttente: null,
            lastMessage: null,
            chatted: false,
            newMessage: false,
            timeStampArrive: null,
            reponseCobrowsing: false,
            geoloc: {},
            histoChat: []
          }
          // si filtrage en front on ajoute ces valeurs
          if (forFiltrageFront) {
            newObjVisiteur['visiteurName'] = message.dataFiltrage.shortdesc
            newObjVisiteur['alreadyConsulted'] = message.dataFiltrage.alreadyConsulted
            newObjVisiteur['autoInvit'] = message.dataFiltrage.autoInvit
            newObjVisiteur['autoInvitType'] = message.dataFiltrage.autoInvitType
            newObjVisiteur['autoinvitSend'] = message.dataFiltrage.autoinvitSend
            newObjVisiteur['dateLastChat'] = message.dataFiltrage.dateLastChat
            newObjVisiteur['getplusinfoavailable'] = message.dataFiltrage.getplusinfoavailable
            newObjVisiteur['key'] = message.dataFiltrage.key
            newObjVisiteur['keyVis'] = message.dataFiltrage.keyVis
            newObjVisiteur['listAlert'] = message.dataFiltrage.listAlert
            newObjVisiteur['nbCustomAlert'] = message.dataFiltrage.nbCustomAlert
            newObjVisiteur['nb_alert'] = message.dataFiltrage.nb_alert
            newObjVisiteur['nbchats'] = message.dataFiltrage.nbchats
            newObjVisiteur['pagesFocus'] = message.dataFiltrage.pagesFocus
            newObjVisiteur['ponderation'] = message.dataFiltrage.ponderation
            newObjVisiteur['savedConversation'] = message.dataFiltrage.savedConversation
            newObjVisiteur['shortdesc'] = message.dataFiltrage.shortdesc
            newObjVisiteur['visId'] = message.dataFiltrage.visId
            newObjVisiteur['visitorApiInfo'] = message.dataFiltrage.visitorApiInfo
            newObjVisiteur['wz_textSocialNotif'] = message.dataFiltrage.wz_textSocialNotif
            // newObjVisiteur.push(
            //   {
            //     visiteurName: message.dataFiltrage.shortdesc,
            //     alreadyConsulted: message.dataFiltrage.alreadyConsulted,
            //     autoInvit: message.dataFiltrage.autoInvit,
            //     autoInvitType: message.dataFiltrage.autoInvitType,
            //     autoinvitSend: message.dataFiltrage.autoinvitSend,
            //     dateLastChat: message.dataFiltrage.dateLastChat,
            //     getplusinfoavailable: message.dataFiltrage.getplusinfoavailable,
            //     key: message.dataFiltrage.key,
            //     keyVis: message.dataFiltrage.keyVis,
            //     listAlert: message.dataFiltrage.listAlert,
            //     nbCustomAlert: message.dataFiltrage.nbCustomAlert,
            //     nb_alert: message.dataFiltrage.nb_alert,
            //     nbchats: message.dataFiltrage.nbchats,
            //     pagesFocus: message.dataFiltrage.pagesFocus,
            //     ponderation: message.dataFiltrage.ponderation,
            //     savedConversation: message.dataFiltrage.savedConversation,
            //     shortdesc: message.dataFiltrage.shortdesc,
            //     visId: message.dataFiltrage.visId,
            //     visitorApiInfo: message.dataFiltrage.visitorApiInfo,
            //     wz_textSocialNotif: message.dataFiltrage.wz_textSocialNotif
            //   }
            // )
          }
          // console.log('newObjVisiteur', newObjVisiteur)
          state.listeAllVisiteurs.push(newObjVisiteur)
        } else if (index !== -1) {
          // si le visiteur est deja dans la liste
          var visiteurSelect = _.cloneDeep(state.listeAllVisiteurs[index])
          visiteurSelect.status = message.newVisiteur[0]
          visiteurSelect.connexion = true
          visiteurSelect.lang = message.newVisiteur[1]
          visiteurSelect.visiteurID = message.newVisiteur[2]
          visiteurSelect.roomName = message.newVisiteur[3]
          visiteurSelect.socketID = message.listeSocketID
          visiteurSelect.siteID = message.newVisiteur[5]
          visiteurSelect.notification = message.newVisiteur[6]
          // visiteurSelect.fileAttente = visiteurSelect.fileAttente
          // visiteurSelect.placePupitre = visiteurSelect.placePupitre

          // les data filtrage
          visiteurSelect.visiteurName = message.dataFiltrage.shortdesc
          visiteurSelect.alreadyConsulted = message.dataFiltrage.alreadyConsulted
          visiteurSelect.autoInvit = message.dataFiltrage.autoInvit
          visiteurSelect.autoInvitType = message.dataFiltrage.autoInvitType
          visiteurSelect.autoinvitSend = message.dataFiltrage.autoinvitSend
          visiteurSelect.dateLastChat = message.dataFiltrage.dateLastChat
          visiteurSelect.getplusinfoavailable = message.dataFiltrage.getplusinfoavailable
          visiteurSelect.key = message.dataFiltrage.key
          visiteurSelect.keyVis = message.dataFiltrage.keyVis
          visiteurSelect.listAlert = message.dataFiltrage.listAlert
          visiteurSelect.nbCustomAlert = message.dataFiltrage.nbCustomAlert
          visiteurSelect.nb_alert = message.dataFiltrage.nb_alert
          visiteurSelect.nbchats = message.dataFiltrage.nbchats
          visiteurSelect.pagesFocus = message.dataFiltrage.pagesFocus
          visiteurSelect.ponderation = message.dataFiltrage.ponderation
          visiteurSelect.savedConversation = message.dataFiltrage.savedConversation
          visiteurSelect.shortdesc = message.dataFiltrage.shortdesc
          visiteurSelect.visId = message.dataFiltrage.visId
          visiteurSelect.visitorApiInfo = message.dataFiltrage.visitorApiInfo
          visiteurSelect.wz_textSocialNotif = message.dataFiltrage.wz_textSocialNotif

          state.listeAllVisiteurs.splice(index, 1, visiteurSelect)
        }
      }
    },

    // -------------------------------------------------------------
    // AJOUTE UN VISITEUR NODEJS
    // -------------------------------------------------------------
    // ADD_VISITEURS (state, visiteur) {
    //   // pour l'object visiteurs
    //   var newObjVisiteur = {
    //     'status': 'online',
    //     'connexion': true,
    //     'lang': visiteur.lang,
    //     'visiteurID': visiteur.visiteurID,
    //     'visiteurName': visiteur.visiteurID,
    //     'network': 'moon',
    //     'profile_pic': '',
    //     'placePupitre': visiteur.placePupitre,
    //     'fileAttente': visiteur.fileAttente,
    //     'lastMessage': visiteur.dataMessage.message,
    //     'newMessage': null,
    //     'timeStampArrive': visiteur.dataMessage.timeStamp,
    //     'histoChat': []
    //   }
    //   state.listeAllVisiteurs.push(newObjVisiteur)
    // },

    // -------------------------------------------------------------
    // AJOUTE UN VISITEUR FACEBOOK
    // -------------------------------------------------------------
    ADD_VISITEURS_SOCIAL (state, visiteur) {
      // pour l'object visiteurs
      var newObjVisiteur = {
        status: 'online',
        connexion: true,
        openFiche: false,
        lang: visiteur.dataMessage.dataVisiteur.locale,
        visiteurID: visiteur.dataMessage.dataVisiteur.id,
        visiteurName:
          visiteur.dataMessage.dataVisiteur.first_name +
          ' ' +
          visiteur.dataMessage.dataVisiteur.last_name,
        networkFirstMessage: true,
        network: visiteur.dataMessage.network,
        profile_pic: visiteur.dataMessage.dataVisiteur.profile_pic,
        placePupitre: visiteur.placePupitre,
        fileAttente: visiteur.fileAttente,
        lastMessage: visiteur.dataMessage.message,
        newMessage: true,
        timeStampArrive: visiteur.dataMessage.time,
        histoChat: []
      }
      state.listeAllVisiteurs.push(newObjVisiteur)
    },

    // -------------------------------------------------------------
    // MISE A JOUR DES DONNEES D'UN VISITEUR DANS LA LISTE
    // -------------------------------------------------------------
    SET_VISITEURS (state, visiteur) {
      console.log('SET_VISITEURS visiteur ==> ', visiteur)
      console.log('SET_VISITEURS state.listeAllVisiteurs ==> ', state.listeAllVisiteurs)
      if (visiteur) {
        // Supprimer tous les doublons existants (au cas où)
        state.listeAllVisiteurs = state.listeAllVisiteurs.filter(
          v => !!v.visiteurID && v.visiteurID !== visiteur.visiteurID
        )
        // console.log('SET_VISITEURS state.listeAllVisiteurs ==> ', state.listeAllVisiteurs)
        // Ajouter le nouveau ou mis à jour
        state.listeAllVisiteurs.push(visiteur)

        // 🚨 Vérification : y a-t-il un doublon maintenant ?
        const ids = state.listeAllVisiteurs.map(v => v.visiteurID)
        const doublons = ids.filter((id, index) => ids.indexOf(id) !== index)
        if (doublons.length) {
          console.warn('[DUPLICATE DETECTED] visiteurID en double :', doublons)
        }
      }
    },

    // -------------------------------------------------------------
    // MISE A JOUR DE L'HISTOCHAT DU VISTEUR OPENED
    // -------------------------------------------------------------
    SET_VISITEURS_OPENED_HISTOCHAT (state, data) {
      // console.log('set visiteur', data)
      if (data) {
        state.allDataVisiteurOpened.histoChat = data
      }
    },

    // -------------------------------------------------------------
    // MISE A JOUR DES DONNEES D'UN VISITEUR OUVERT DANS LA LISTE DES MESSAGE EN ATTENTE
    // -------------------------------------------------------------
    SET_VISITEURS_ALL_DATA_MESSAGE_ATTENTE (state, visiteur) {
      console.log('SET_VISITEURS_ALL_DATA_MESSAGE_ATTENTE', visiteur)
      if (visiteur) {
        state.allDataVisiteurOpened = visiteur
      }
    },

    // -------------------------------------------------------------
    // MISE A JOUR DES DONNEES D'UN CONTACT OUVERT DANS LA LISTE DES CONTACT
    // -------------------------------------------------------------
    SET_CONTACT_ALL_DATA (state, visiteur) {
      console.log('SET_CONTACT_ALL_DATA', visiteur)
      if (visiteur) {
        state.contactOpened = visiteur
      } else {
        state.contactOpened = {}
      }
    },

    // -------------------------------------------------------------
    // MISE A JOUR DE L'HISTOCHAT DU contact ouvert
    // -------------------------------------------------------------
    SET_CONTACT_OPENED_HISTOCHAT (state, data) {
      // console.log('set visiteur', data)
      if (data) {
        state.contactOpened.histoChat = data
      }
    },

    // -------------------------------------------------------------
    // MISE A JOUR DE LA LISTE DES CONTACTS RESEAUX SOCIAUX
    // -------------------------------------------------------------
    SET_LIST_CONTACT_RESEAUX (state, data) {
      // console.log('SET_LIST_CONTACT_RESEAUX', data)
      if (data.listeContact) {
        // retire les doublons de la liste des contact
        let listeContact = _.uniqBy(data.listeContact, 'userId')
        state.listeContactReseaux = listeContact
        // console.log('listeContact', listeContact)
      }
    },

    // // -------------------------------------------------------------
    // // CHANGE LA ROUTE
    // // -------------------------------------------------------------
    // CHANGE_ROUTE (state, data) {
    //   console.log('CHANGE_ROUTE', data)
    //   _watcheebox.changeFocusAgent({
    //     // 'socket': this.$socket,
    //     datasAgent: data.datasAgent,
    //     focusSessionID: 1,
    //     focusAgent: window.lastFocusStatus
    //   })
    // },

    // -------------------------------------------------------------
    // OUVRE LA FICHE VISITEUR DANS LA LISTE VISITEUR
    // -------------------------------------------------------------
    OPEN_FICHE_VISITEUR (state, visiteur) {
      // console.log('open fiche visiteur', visiteur.agentId)
      state.idAgentSelectedListe = visiteur.agentId // id de l'agent selectionné dans la liste
      // pour l'object visiteurs
      var index = _.findIndex(state.listeAllVisiteurs, {
        visiteurID: visiteur.visiteurID
      })
      if (index === -1) return
      var visiteurSelect = _.cloneDeep(state.listeAllVisiteurs[index])
      visiteurSelect.openFiche = true
      // state.listeAllVisiteurs.splice(index, 1, visiteurSelect)
      // 🔁 Réutiliser la logique centralisée
      this.commit('SET_VISITEURS', visiteurSelect)
    },

    // -------------------------------------------------------------
    // FERME LA FICHE VISITEUR DANS LA LISTE VISITEUR
    // -------------------------------------------------------------
    CLOSE_FICHE_VISITEUR (state, visiteur) {
      console.log('close fiche visiteur', visiteur)
      state.idAgentSelectedListe = false // plus d'agent selectionné
      // pour l'object visiteurs
      var index = _.findIndex(state.listeAllVisiteurs, {
        visiteurID: visiteur.visiteurID
      })
      if (index === -1) return
      if (state.listeAllVisiteurs[index].connexion) {
        var visiteurSelect = _.cloneDeep(state.listeAllVisiteurs[index])
        visiteurSelect.openFiche = false
        state.listeAllVisiteurs.splice(index, 1, visiteurSelect) // modification des données visiteur
      } else {
        state.listeAllVisiteurs.splice(index, 1) // efface ce visiteur
      }
      console.log('[index]', state.listeAllVisiteurs)
    },

    // -------------------------------------------------------------
    // EFFACE LE VISITEUR DE LA LISTE
    // -------------------------------------------------------------
    REMOVE_VISITEUR (state, visiteur) {
      // pour l'object visiteurs
      var index = _.findIndex(state.listeAllVisiteurs, {
        visiteurID: visiteur.visiteurID
      })
      if (index === -1) return
      state.listeAllVisiteurs.splice(index, 1)
    },

    // -------------------------------------------------------------
    // efface le visiteur à l'index
    // -------------------------------------------------------------
    REMOVE_VISITEUR_BY_INDEX (state, index) {
      state.listeAllVisiteurs.splice(index, 1)
    },

    // -----------------------------------------------------------
    // Nouveau message client
    // Affiche le premier message du visiteur
    // connect l'agent à la room perso du visiteur
    // -----------------------------------------------------------
    SOCKET_UPDATE_CHAT (state, message) {
      console.log('SOCKET_UPDATE_CHAT', message)
      // avant d'afficher le chat il faut bien verifier que le nomnre de chatsMax n'est pas depassé
      if (state.sessionsPrivees.length < this.getters['_User/user'].chatsMax) {
        // console.log('il y a de la place en sessionsPrivees')
        // il faut regarder dans les sessions privées si je ne suis pas deja en chat avec lui
        let indexSessionChat = _.findIndex(state.sessionsPrivees, [
          1,
          message.messageChat.chatSession
        ])

        console.log(
          state.listeAllVisiteurs.map(v => `"${v.visiteurID}"`)
        )
        console.log('message.messageChat.chatSession', message.messageChat.chatSession)
        const target = message.messageChat.chatSession
        let index = _.findIndex(state.listeAllVisiteurs, v => {
          return String(v.visiteurID).trim() === String(target).trim()
        })
        console.log('index', index)
        var indexSession = message.indexSession
        let nameAuteur = message.messageChat.chatSession
        if (
          message.messageChat.nameAuteur &&
          message.messageChat.auteur === 'Agent'
        ) {
          // pour les agents
          nameAuteur = message.messageChat.nameAuteur
        } else if (index !== -1 && state.listeAllVisiteurs[index].visiteurName) {
          // pour les visiteur
          nameAuteur = state.listeAllVisiteurs[index].visiteurName
        }
        // ------- pour les sessions chats
        var dataSession = [
          message.messageChat.clientSocketID,
          message.messageChat.chatSession,
          message.messageChat.WZAgentId,
          nameAuteur
        ]
        console.log('indexSession', indexSession)
        // si pas encore en chat avec moi,
        if (indexSession === -1) {
          // let newMessage = {}
          var newObjVisiteur = {
            status: 'online',
            connexion: true,
            lang: 'fr',
            visiteurID: message.messageChat.chatSession,
            roomName: message.messageChat.chatSession,
            socketID: message.messageChat.clientSocketID,
            siteID: message.messageChat.siteId,
            notification: '',
            placePupitre: null,
            fileAttente: null,
            chatted: false,
            lastMessage: null,
            newMessage: true,
            timeStampArrive: null,
            geoloc: {},
            histoChat: message.histoChat
          }
          // console.log('newObjVisiteur', newObjVisiteur)
          // Google Analytics
          // cela déclenche un event GA en front
          _watcheebox.envoisMessage({
            agentSocketID: state.mySocketID,
            datasAgent: this.getters['_User/user'],
            datasVisiteur: newObjVisiteur,
            message: 'analytics',
            messageType: 11,
            filterId: 0,
            agentName: ''
          })
          // fin Google
          console.log('state.listeAllVisiteurs[index]', state.listeAllVisiteurs[index])
          let arrayVisiteur = _.cloneDeep(state.listeAllVisiteurs[index]) // nouveau tableau
          // si ce visiteur n'existe pas dans la liste
          // on l'ajoute afin d'avoir sa référence
          // et pouvoir chatter avec lui
          if (index === -1) {
            state.listeAllVisiteurs.push(newObjVisiteur)
            index = state.listeAllVisiteurs.length - 1
          // sinon il faut modifier les données de ce visiteur
          } else {
            arrayVisiteur.status = newObjVisiteur.status
            arrayVisiteur.connexion = newObjVisiteur.connexion
            // arrayVisiteur.lang = newObjVisiteur.lang
            arrayVisiteur.visiteurID = newObjVisiteur.visiteurID
            // arrayVisiteur.roomName = newObjVisiteur.roomName
            // arrayVisiteur.socketID = newObjVisiteur.socketID
            // arrayVisiteur.siteID = newObjVisiteur.siteID
            // arrayVisiteur.notification = newObjVisiteur.notification
            // arrayVisiteur.placePupitre = newObjVisiteur.placePupitre
            // arrayVisiteur.fileAttente = newObjVisiteur.fileAttente
            arrayVisiteur.chatted = newObjVisiteur.chatted
            arrayVisiteur.lastMessage = newObjVisiteur.lastMessage
            arrayVisiteur.newMessage = newObjVisiteur.newMessage
            arrayVisiteur.timeStampArrive = newObjVisiteur.timeStampArrive
            // arrayVisiteur.geoloc = newObjVisiteur.geoloc
            arrayVisiteur.histoChat = newObjVisiteur.histoChat ? newObjVisiteur.histoChat : []
          }
          // uniquement si ce message vient d'un visiteur qui est ni sur le pupitre ni en file d'attente
          // si ce message est bien pour moi
          if (message.messageChat.WZAgentId === this.getters['_User/user'].id) {
            // indique que c'est un nouveau message
            // pour ouverture automatique du chat dans 'visiteur'
            console.log('state.newMessage', newObjVisiteur)
            state.newMessage = {
              timestamp: message.messageChat.timeStamp,
              type: message.messageChat.messageType,
              nameAuteur: nameAuteur,
              message: message.messageChat.message,
              auteur: message.messageChat.auteur,
              visitorId: message.messageChat.chatSession,
              attachments: message.messageChat.attachments
            }
            // ajoute le message dans l'histoChat du visiteur
            console.log('newObjVisiteur', newObjVisiteur)
            console.log('arrayVisiteur', arrayVisiteur)
            console.log('=')
            console.log('message.histoChat', message.histoChat)
            arrayVisiteur.histoChat = message.histoChat

            if (
              arrayVisiteur.placePupitre === null &&
              arrayVisiteur.fileAttente === null
            ) {
              if (
                this.getters['_User/user'].entId === '4425'
              ) {
                this.commit('_StoreWatcheeBox/PLAY_SOUND_CONVERSATION2') // son nouvelle conversation
              } else {
                this.commit('_StoreWatcheeBox/PLAY_SOUND_CONVERSATION') // son nouvelle conversation
              }
              // mise a jours des message visiteur uniquement
              if (message.messageChat.auteur === 'Visiteur') {
                _watcheebox.receptionMessage({
                  agentSocketID: state.mySocketID,
                  siteID: message.messageChat.siteId,
                  datasAgent: this.getters['_User/user'],
                  datasVisiteur: newObjVisiteur,
                  ARType: 1,
                  messageID: message.messageChat.timeStamp
                })
              }
              // affiche ce message uniquement si pas deja focus sur le chat
              // evite le message en doublon pour la page visiteur uniquement
              // if (
              //   arrayVisiteur.histoChat.length &&
              //   state.focusPupitre.focusSessionID !==
              //     message.messageChat.chatSession
              // ) {

              // }
              arrayVisiteur.newMessage = true
              arrayVisiteur.timeStampArrive = Date.now()
              arrayVisiteur.dataMessage = message.messageChat
              var placeOccupe = []
              // parse le tableau pour trouver le visiteur
              _.forEach(state.listeAllVisiteurs, (allVisiteurs, key) => {
                if (
                  allVisiteurs.visiteurID === message.messageChat.chatSession
                ) {
                  // visiteurDejaLa = true
                }
                if (allVisiteurs.placePupitre) {
                  placeOccupe.push(allVisiteurs.placePupitre)
                }
              })

              // Si plus de places dispo dans le pupitre on l'ajoute en file d'attente
              if (placeOccupe.length > 3) {
                arrayVisiteur.timeStampArrive = Date.now()
                arrayVisiteur.fileAttente = this.getters['_User/user'].id // ajoute l'id agent dans fileAttente
                arrayVisiteur.placePupitre = null
                arrayVisiteur.lastMessage = message.messageChat.message
                // Si il reste de la place dans le pupitre
              } else {
                var placePupitre = [1, 2, 3, 4]
                var placesDispo = _.difference(placePupitre, placeOccupe)
                arrayVisiteur.fileAttente = null
                arrayVisiteur.placePupitre = placesDispo[0] // la premiere place dispo qui reste
              }

              // si pas de session chat existante pour ce visiteur
              // on l'ajoute
              this.commit('_StoreWatcheeBox/ADD_PRIVATE_SESSION_CHAT', {
                session: dataSession,
                visiteur: arrayVisiteur
              })

              // envois au serveur de chat l'ajout de cette session chat
              _watcheebox.totalConversations({
                datasAgent: this.getters['_User/user'],
                agentSocketID: state.mySocketID,
                arrayVisiteur: arrayVisiteur,
                sessionsPrivees: state.sessionsPrivees,
                status: 'plus'
              })

              // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
              // Il faut voir avec la route car uniquement sur chatting et visiteur
              // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
              // si pas focus sur le BO envois d'une notif browser
              if (!state.focusPupitre.myFocus && indexSessionChat === -1) {
                Push.create('Nouvelle conversation de ' + nameAuteur, {
                  body: message.messageChat.message,
                  tag: message.messageChat.chatSession,
                  icon: {
                    x16: AWSS3_STATIC + '/img/logo/logo_16.png',
                    x32: AWSS3_STATIC + '/img/logo/logo_32.png'
                  },
                  requireInteraction: true,
                  onClick: function () {
                    window.focus() // redonne le focus
                    this.close() // ferme la bonne notification
                    window.location =
                      process.env.NODE_ENV === 'development'
                        ? `${DOMAINE}/watcheezy/#/trafic/chatting`
                        : `${DOMAINE}/#/trafic/chatting`
                  }
                }).catch(() => {})
              }
              if (
                state.focusPupitre.focusSessionID !==
                message.messageChat.chatSession
              ) {
                // l'icone de la notification
                var iconeNotification = 'message'
                this.dispatch('_Notifier/NEW_NOTIF', {
                  message: 'Nouvelle conversation de ' + nameAuteur,
                  context: 'info',
                  position: 'top',
                  type: iconeNotification,
                  multiLine: true,
                  vu: false,
                  data: {
                    titre: message.messageChat.chatSession,
                    message: message.messageChat.message,
                    timestamp: message.messageChat.timeStamp * 1000
                  } // clone le visiteur
                })
              }
            }
            // connect l'agent à la room visiteur
            _watcheebox.clientConnectRoom({
              roomName: 'chat_' + message.messageChat.chatSession
            })
          }

          // slack
          let slack = this.getters['_User/user'].entSlack
          if (slack === 'slack' || slack === '1') {
            axios
              .get(
                'get/slack_firstMsg.php?msg=' +
                  message.messageChat.message +
                  '&vis=' +
                  message.messageChat.chatSession
              )
              .then(response => {})
          }
          // end slack
          // premiere reponse automatique
          let autoAnswser = ''
          if (
            this.getters['_Sites/GET_SITE_BY_ID'](newObjVisiteur.siteID)
              .DSK_AUTOANSWER_ONOFF === '1'
          ) {
            let mesAuto = this.getters['_Sites/GET_SITE_BY_ID'](
              newObjVisiteur.siteID)
            autoAnswser = JSON.parse(mesAuto.DSK_AUTOANSWER_MSG)[mesAuto.LIC_DEFAULT_LANG]
          }
          if (autoAnswser) {
            _watcheebox.envoisMessage({
              agentSocketID: state.mySocketID,
              datasAgent: this.getters['_User/user'],
              datasVisiteur: newObjVisiteur,
              message: autoAnswser,
              messageType: 2,
              filterId: 0,
              agentName: ''
            })
          }
          console.log('arrayVisiteur', arrayVisiteur)
          state.listeAllVisiteurs.splice(index, 1, arrayVisiteur)
          // end premiere reponse automatique
        } else {
          // ------------------------------------------------------------------------------
          // il faut remetre une place pupitre ici si jamais elle n'est plus la
          console.log('visiteur deja en session chat avec moi', message.messageChat)
          console.log('state.listeAllVisiteurs[index].placePupitre', state.listeAllVisiteurs[index].placePupitre)
          if (state.listeAllVisiteurs[index].placePupitre === null) {
            let placeOccupe = []
            // parse le tableau pour trouver le visiteur
            _.forEach(state.listeAllVisiteurs, (allVisiteurs, key) => {
              if (allVisiteurs.visiteurID === message.messageChat.chatSession) {
                // visiteurDejaLa = true
              }
              if (allVisiteurs.placePupitre) {
                placeOccupe.push(allVisiteurs.placePupitre)
              }
            })

            // Si plus de places dispo dans le pupitre on l'ajoute en file d'attente
            if (placeOccupe.length > 3) {
              state.listeAllVisiteurs[index].timeStampArrive = Date.now()
              state.listeAllVisiteurs[index].fileAttente = this.getters['_User/user'].id // ajoute l'id agent dans fileAttente
              state.listeAllVisiteurs[index].placePupitre = null
              state.listeAllVisiteurs[index].lastMessage = message.messageChat.message
              // Si il reste de la place dans le pupitre
            } else {
              let placePupitre = [1, 2, 3, 4]
              let placesDisponible = _.difference(placePupitre, placeOccupe)
              state.listeAllVisiteurs[index].fileAttente = null
              state.listeAllVisiteurs[index].placePupitre = placesDisponible[0]
            }
          }
          // ------------------------------------------------------------------------------
          // ------------------------------------------------------------------------------

          // si deja une session chat existante pour ce visiteur
          // on la modifie
          this.commit('_StoreWatcheeBox/UPDATE_PRIVATE_SESSION_CHAT', {
            session: dataSession,
            index: indexSession
          })
          // on ajout ca place dans listeAllVisiteur
          // state.listeAllVisiteurs[index].placePupitre = arrayVisiteur.placePupitre
        }
      } else {
        console.log('il est impossible de prendre en charge ce client > chatsMax')
        // // envois un message au visiteur
        // let dataAgent = this.getters['_User/user']
        // let agentFullName = dataAgent.fname + ' ' + dataAgent.lname
        // let dataVisiteur = {
        //   status: 'online',
        //   connexion: true,
        //   lang: 'fr',
        //   visiteurID: message.messageChat.chatSession,
        //   roomName: message.messageChat.chatSession,
        //   socketID: message.messageChat.clientSocketID,
        //   siteID: message.messageChat.siteId,
        //   notification: '',
        //   placePupitre: null,
        //   fileAttente: null,
        //   chatted: false,
        //   lastMessage: null,
        //   newMessage: true,
        //   timeStampArrive: null,
        //   geoloc: {},
        //   histoChat: message.histoChat
        // }
        // // envois un message system au visiteur
        // _watcheebox.envoisMessage({
        //   // 'socket': this.$socket,
        //   agentSocketID: state.mySocketID,
        //   datasAgent: dataAgent,
        //   datasVisiteur: dataVisiteur,
        //   message: 'Aucuns conseillés disponibles pour vous répondre',
        //   attachments: '',
        //   messageType: 7,
        //   agentName: unescape(agentFullName)
        // })
      }
      // console.log('liste chat ', state.listeAllVisiteurs[index])
    },

    // -----------------------------------------------------------
    // Affiche le message dans la room du client
    // mais ne pas afficher mes messages que j'ai envoyé
    // car ils sont affichés directement dans le chat sans passer par nodejs
    // -----------------------------------------------------------
    SOCKET_UPDATE_CHAT_ROOM (state, message) {
      console.log('SOCKET_UPDATE_CHAT_ROOM', message)
      // Si c'est un de mes messages evoyés je n'affiche rien
      if (
        message.messageChat.WZAgentId === this.getters['_User/user'].id &&
        message.messageChat.auteur === 'Agent'
      ) {
        console.log('message agent')
        // c'est un message de type 1
      } else if (message.messageChat.messageType === 1) {
        console.log('message visiteur')
        // tous les autres messages sont affichés
        let index = _.findIndex(state.listeAllVisiteurs, {
          visiteurID: message.messageChat.chatSession
        })
        console.log('index visiteur', index)
        // var indexSession = _.findIndex(state.sessionsPrivees, [1, message.messageChat.chatSession])
        let nameAuteur = message.messageChat.chatSession
        console.log('state.listeAllVisiteurs[index]', state.listeAllVisiteurs[index])
        if (
          message.messageChat.nameAuteur &&
          message.messageChat.auteur === 'Agent'
        ) {
          // pour les agents
          nameAuteur = message.messageChat.nameAuteur
        } else if (state.listeAllVisiteurs[index].visiteurName) {
          // pour les visiteur
          nameAuteur = state.listeAllVisiteurs[index].visiteurName
        }
        var msg = message.messageChat.message
        if (message.messageChat.message === '' && message.messageChat.jsonaAPI.length) {
          msg = message.messageChat.jsonaAPI
        }
        // si visiteur deja dans la liste
        if (index !== -1) {
          var newMessage = {
            attachments: message.messageChat.attachments,
            auteur: message.messageChat.auteur,
            message: msg,
            nameAuteur: nameAuteur,
            timestamp: message.messageChat.timeStamp,
            type: message.messageChat.messageType,
            lu: 0,
            visitorId: message.messageChat.chatSession,
            agentId: message.messageChat.WZAgentId
          }
          // ajoute le nouveau message
          state.listeAllVisiteurs[index].histoChat.push(newMessage)
          // ajoute ce nouveau message dans 'lastMessage' pour le visiteurs en attente
          state.listeAllVisiteurs[index].lastMessage = message.messageChat.message
          // indique l'ouverture d'un nouveau chat avec un nouveau message
          // state.listeAllVisiteurs[index].newMessage = true

          // mise a jours des message visiteur uniquement
          if (message.messageChat.auteur === 'Visiteur') {
            _watcheebox.receptionMessage({
              agentSocketID: state.mySocketID,
              siteID: message.messageChat.siteId,
              datasAgent: this.getters['_User/user'],
              datasVisiteur: state.listeAllVisiteurs[index],
              ARType: 2,
              messageID: message.messageChat.timeStamp
            })
          }
          // }

          // indique visuellement l'arrivé d'un nouveau message
          // dans le bon chat client

          // if (
          //   window.document.getElementById(
          //     'chat_' + message.messageChat.chatSession
          //   )
          // ) {
          //   let chat = window.document.getElementById(
          //     'chat_' + message.messageChat.chatSession
          //   )
          //   let chatToolbar = chat.firstChild
          //   // si je suis focus sur ce visiteur
          //   if (
          //     state.focusPupitre.focusSessionID ===
          //     message.messageChat.chatSession
          //   ) {
          //     // et uniquement si je suis pas focus sur le bo
          //     if (!state.focusPupitre.myFocus) {
          //       chatToolbar.classList.add('newMessageFocus')
          //     }
          //   } else {
          //     chatToolbar.classList.add('newMessage')
          //   }
          // }

          // play son uniquement pour le destinataire du message
          if (message.messageChat.WZAgentId === this.getters['_User/user'].id) {
            // efface le dernier message car je suis focus sur ce chat
            // pour ne pas le réafficher dans la liste des visteurs
            if (state.visiteurChatSelected === message.messageChat.chatSession) {
              // state.listeAllVisiteurs[index].lastMessage = ''
            }
            // console.log('WZAgentId', this.getters['_User/user'].id)
            this.commit('_StoreWatcheeBox/PLAY_SOUND_MESSAGE_FOCUS_IN') // son pour chaque message si focus sur le BO
            // mais pas focus sur le chat
            if (
              state.focusPupitre.focusSessionID !==
              message.messageChat.chatSession
            ) {
              // l'icone de la notification
              var iconeNotification = 'message'
              let txt = `${i18n.t('notifNewMessage')}` + ' ' + nameAuteur + ' : ' + message.messageChat.message
              this.dispatch('_Notifier/NEW_NOTIF', {
                message: txt,
                context: 'info',
                position: 'top',
                type: iconeNotification,
                multiLine: true,
                vu: false,
                data: {
                  titre: message.messageChat.chatSession,
                  message: message.messageChat.message,
                  timestamp: message.messageChat.timeStamp * 1000,
                  visiteurID: message.messageChat.chatSession
                } // clone le visiteur
              })
            }
            // si je suis focus sur le BO
            if (!state.focusPupitre.myFocus) {
              if (
                this.getters['_User/user'].entId === '4425'
              ) {
                this.commit('_StoreWatcheeBox/PLAY_SOUND_MESSAGE_FOCUS_OUT2') // son pour chaque message non focus Pour ID2son ent_id 4425
              } else {
                this.commit('_StoreWatcheeBox/PLAY_SOUND_MESSAGE_FOCUS_OUT') // son pour chaque message non focus sur le BO
              }
              // et affiche un push navigateur
              let txt = `${i18n.t('notifNewMessage')}` + ' ' + nameAuteur
              Push.create(txt, {
                body: message.messageChat.message,
                tag: message.messageChat.chatSession,
                icon: {
                  x16: AWSS3_STATIC + '/img/logo/logo_16.png',
                  x32: AWSS3_STATIC + '/img/logo/logo_32.png'
                },
                requireInteraction: true,
                onClick: function () {
                  window.focus() // redonne le focus
                  this.close() // ferme la bonne notification
                  window.location =
                    process.env.NODE_ENV === 'development'
                      ? `${DOMAINE}/watcheezy/#/trafic/chatting`
                      : `${DOMAINE}/#/trafic/chatting`
                }
              }).catch(() => {})
            }
          }
        }
      } else if (message.messageChat.messageType === 18) {
        console.log('Notification de message bot')
        let index = _.findIndex(state.listeAllVisiteurs, {
          visiteurID: message.messageChat.chatSession
        })
        let messageBot = {
          attachments: message.messageChat.attachments,
          auteur: 'Notification',
          message: message.messageChat.message,
          nameAuteur: '',
          timestamp: message.messageChat.timeStamp,
          type: message.messageChat.messageType,
          visitorId: message.messageChat.chatSession,
          agentId: message.messageChat.WZAgentId
        }
        // ajoute le nouveau message
        state.listeAllVisiteurs[index].histoChat.push(messageBot)
      }
    },

    // --------------------------------------------------------------------
    // Marque le "message envoyé" comme "message lu"
    // --------------------------------------------------------------------
    SOCKET_UPDATE_CHAT_DELIVRE (state, message) {
      // pour l'object visiteurs
      var index = _.findIndex(state.listeAllVisiteurs, {
        visiteurID: message.visitorId
      })
      if (index === -1) return
      var indexMessage = _.findIndex(state.listeAllVisiteurs[index].histoChat, {
        timestamp: message.timestamp
      })
      if (indexMessage === -1) return
      state.listeAllVisiteurs[index].histoChat[indexMessage].status = 'read'
    },

    // --------------------------------------------------------------------
    // Message chat lu
    // --------------------------------------------------------------------
    SOCKET_UPDATE_CHAT_LU (state, message) {
      // pour l'object visiteurs
      var index = _.findIndex(state.listeAllVisiteurs, {
        visiteurID: message.visitorId
      })
      if (index === -1) return
      var indexMessage = _.findIndex(state.listeAllVisiteurs[index].histoChat, {
        timestamp: message.timestamp
      })
      if (indexMessage === -1) return
      state.listeAllVisiteurs[index].histoChat[indexMessage].lu = 1
    },

    // --------------------------------------------------------------------
    // marqueur de message non lu
    // --------------------------------------------------------------------
    SOCKET_MAKE_CHAT_NON_LU (state, message) {
      // pour l'object visiteurs
      var index = _.findIndex(state.listeAllVisiteurs, {
        visiteurID: message.visitorId
      })
      if (index === -1) return
      var indexMessage = _.findIndex(state.listeAllVisiteurs[index].histoChat, {
        timestamp: message.timestamp
      })
      if (indexMessage === -1) return
      var marquerChatNonLu = {
        marqueurMessageNonLu: true,
        messageNonLu: 1,
        type: '1',
        visiteurID: message.visitorId
      }
      state.listeAllVisiteurs[index].histoChat.splice(
        indexMessage,
        0,
        marquerChatNonLu
      )
    },

    // --------------------------------------------------------------------
    // Efface le marqueur de message non lu
    // --------------------------------------------------------------------
    SOCKET_REMOVE_CHAT_NON_LU (state, message) {
      // pour l'object visiteurs
      var index = _.findIndex(state.listeAllVisiteurs, {
        visiteurID: message.visitorId
      })
      if (index === -1) return
      var indexMarqueur = _.findIndex(
        state.listeAllVisiteurs[index].histoChat,
        { marqueurMessageNonLu: true }
      )
      if (indexMarqueur === -1) return
      // efface le marqueur trouvé
      state.listeAllVisiteurs[index].histoChat.splice(indexMarqueur, 1)
    },

    // --------------------------------------------------------------------
    // Reception d'un message socialNetwork quand agent offline
    // page attente et chat ouvert
    // --------------------------------------------------------------------
    SOCKET_UPDATE_CHAT_SOCIAL_OFFLINE (state, message) {
      console.log('SOCKET_UPDATE_CHAT_SOCIAL_OFFLINE', message)
      let nameAuteurMessage = message.messageChat.dataVisiteur.first_name + ' ' + message.messageChat.dataVisiteur.last_name
      var newMessage = {
        attachments: message.messageChat.attachments,
        auteur: message.messageChat.auteur,
        message: message.messageChat.message,
        nameAuteur: nameAuteurMessage,
        timestamp: message.messageChat.time,
        type: '1',
        lu: message.messageChat.lu,
        visitorId: message.messageChat.senderID,
        agentId: message.messageChat.agentID
      }
      // ajoute le message dans l'historique du chat ouvert dans la page attente
      state.allDataVisiteurOpened.histoChat.push(newMessage)
    },

    // --------------------------------------------------------------------
    // Reception d'un message socialNetwork quand agent online
    // --------------------------------------------------------------------
    SOCKET_UPDATE_CHAT_SOCIAL (state, message) {
      console.log('SOCKET_UPDATE_CHAT_SOCIAL', message)
      var index = _.findIndex(state.listeAllVisiteurs, {
        visiteurID: message.messageChat.senderID
      })
      var indexSession = _.findIndex(state.sessionsPrivees, [
        1,
        message.messageChat.senderID
      ])
      let nameAuteur = 'undefined'
      if (message.messageChat.dataVisiteur) {
        nameAuteur =
          message.messageChat.dataVisiteur.first_name +
          ' ' +
          message.messageChat.dataVisiteur.last_name
      }
      // si visiteur deja dans la liste
      if (index !== -1) {
        var newMessage = {
          attachments: message.messageChat.attachments,
          auteur: message.messageChat.auteur,
          message: message.messageChat.message,
          nameAuteur: nameAuteur,
          timestamp: message.messageChat.time,
          type: '1',
          lu: 0,
          visitorId: message.messageChat.senderID,
          agentId: message.messageChat.WZAgentId
        }
        // ajoute le nouveau message
        state.listeAllVisiteurs[index].histoChat.push(newMessage)
        // ajoute ce nouveau message dans 'lastMessage' pour le visiteurs en attente
        state.listeAllVisiteurs[index].lastMessage = message.messageChat.message
        // indique l'ouverture d'un nouveau chat avec un nouveau message
        // state.listeAllVisiteurs[index].newMessage = true

        // indique visuellement l'arrivé d'un nouveau message
        // dans le bon chat client
        // if (
        //   window.document.getElementById('chat_' + message.messageChat.senderID)
        // ) {
        //   let chat = window.document.getElementById(
        //     'chat_' + message.messageChat.senderID
        //   )
        //   let chatToolbar = chat.firstChild
        //   // si je suis focus sur ce visiteur
        //   if (
        //     state.focusPupitre.focusSessionID === message.messageChat.senderID
        //   ) {
        //     // et uniquement si je suis pas focus sur le bo
        //     if (!state.focusPupitre.myFocus) {
        //       chatToolbar.classList.add('newMessageFocus')
        //     }
        //   } else {
        //     chatToolbar.classList.add('newMessage')
        //   }
        // }

        // si il est deja en chat avec moi
        if (indexSession !== -1) {
          // pas focus sur le visiteur
          if (
            state.focusPupitre.focusSessionID !== message.messageChat.senderID
          ) {
            if (
              this.getters['_User/user'].entId === '4425'
            ) {
              this.commit('_StoreWatcheeBox/PLAY_SOUND_MESSAGE_FOCUS_OUT2') // son pour chaque message non focus Pour ID2son ent_id 4425
            } else {
              this.commit('_StoreWatcheeBox/PLAY_SOUND_MESSAGE_FOCUS_OUT') // son pour chaque message non focus sur le BO
            }
            // si focus sur le BO mais pas sur le bon visiteur
            // envois d'une notif BO
            let txt = `${i18n.t('notifNewMessage')}` + ' ' + message.messageChat.senderID + ' : ' + message.messageChat.message
            // le message
            var messageNotif = txt
            // l'icone de la notification
            var iconeNotification = 'message'
            // le "type" correspond a une icone
            this.dispatch('_Notifier/NEW_NOTIF', {
              message: messageNotif,
              context: 'info',
              position: 'top',
              type: iconeNotification,
              multiLine: true,
              vu: false,
              data: {
                titre: message.messageChat.senderID
              } // clone le visiteur
            })
            // sinon focus sur le visiteur
          } else {
            this.commit('_StoreWatcheeBox/PLAY_SOUND_MESSAGE_FOCUS_IN')
          }
        }

        // sinon on ajoute ce nouveau visiteur
      } else {
        if (
          this.getters['_User/user'].entId === '4425'
        ) {
          this.commit('_StoreWatcheeBox/PLAY_SOUND_CONVERSATION2') // son nouvelle conversation Pour ID2son ent_id 4425
        } else {
          this.commit('_StoreWatcheeBox/PLAY_SOUND_CONVERSATION') // son nouvelle conversation
        }
        var arrayVisiteur = {} // nouveau tableau
        arrayVisiteur.visiteurID = message.messageChat.senderID
        let visiteurDejaLa = false
        // si ce message est bien pour moi
        if (message.messageChat.agentID === this.getters['_User/user'].id) {
          // ------- pour les sessions chats
          var dataSession = [
            'facebook', // socketID
            message.messageChat.dataVisiteur.id, // visiteur id
            message.messageChat.agentID, // agent id
            nameAuteur // name sender
          ]
          arrayVisiteur.dataMessage = message.messageChat
          var placeOccupe = []
          // parse le tableau pour trouver le visiteur
          _.forEach(state.listeAllVisiteurs, (allVisiteurs, key) => {
            if (allVisiteurs.visiteurID === message.messageChat.senderID) {
              visiteurDejaLa = true
            }
            if (allVisiteurs.placePupitre) {
              placeOccupe.push(allVisiteurs.placePupitre)
            }
          })

          // Si plus de places dispo dans le pupitre on l'ajoute en file d'attente
          if (placeOccupe.length > 3) {
            arrayVisiteur.timeStampArrive = Date.now()
            arrayVisiteur.fileAttente = this.getters['_User/user'].id // ajoute l'id agent dans fileAttente
            arrayVisiteur.placePupitre = null
            arrayVisiteur.lastMessage = message.messageChat.message
            // Si il reste de la place dans le pupitre
          } else {
            var placePupitre = [1, 2, 3, 4]
            var placesDispo = _.difference(placePupitre, placeOccupe)
            arrayVisiteur.fileAttente = null
            arrayVisiteur.placePupitre = placesDispo[0] // la premiere place dispo qui reste
          }

          // enregistre les donnée du visiteur dans le store
          // si le visiteur n'est pas encore dans "listeAllVisiteurs"
          if (!visiteurDejaLa) {
            // on ajoute ce visiteur dedans
            this.commit('_StoreWatcheeBox/ADD_VISITEURS_SOCIAL', arrayVisiteur)
          }

          // envois au serveur de chat l'ajout de cette session chat
          _watcheebox.totalConversations({
            // 'socket': this._vm.$socket,
            datasAgent: this.getters['_User/user'],
            agentSocketID: state.mySocketID,
            arrayVisiteur: arrayVisiteur,
            sessionsPrivees: state.sessionsPrivees,
            status: 'plus'
          })

          // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
          // Il faut voir avec la route car uniquement sur chatting et visiteur
          // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
          // si pas focus sur le BO envois d'une notif browser
          if (!state.focusPupitre.myFocus) {
            Push.create('Nouvelle conversation de ' + nameAuteur, {
              body: message.messageChat.message,
              tag: message.messageChat.senderID,
              icon: {
                x16: AWSS3_STATIC + '/img/logo/logo_16.png',
                x32: AWSS3_STATIC + '/img/logo/logo_32.png'
              },
              requireInteraction: true,
              onClick: function () {
                window.focus() // redonne le focus
                this.close() // ferme la bonne notification
                window.location =
                  process.env.NODE_ENV === 'development'
                    ? `${DOMAINE}/watcheezy/#/trafic/chatting`
                    : `${DOMAINE}/#/trafic/chatting`
              }
            }).catch(() => {})
          } else {
            // l'icone de la notification
            iconeNotification = 'message'
            this.dispatch('_Notifier/NEW_NOTIF', {
              message:
                'Nouvelle conversation de ' + nameAuteur + ' via facebook',
              context: 'info',
              position: 'top',
              type: iconeNotification,
              multiLine: true,
              vu: false,
              data: { titre: message.messageChat.senderID } // clone le visiteur
            })
          }
        }
        // this.ajoutNewVisiteurSocialNetwork(val) // ajoute ce nouveau visiteur facebook dans "listeAllVisiteurs"
        if (indexSession === -1) {
          // si pas de session chat existante pour ce visiteur
          // on l'ajoute
          this.commit('_StoreWatcheeBox/ADD_PRIVATE_SESSION_CHAT', {
            session: dataSession,
            visiteur: arrayVisiteur
          })
        }
      }
      // state.lastMessage = message.messageChat
    },

    // --------------------------------------------------------------------
    // Message socialnetwork delivré
    // --------------------------------------------------------------------
    SOCKET_UPDATE_CHAT_SOCIAL_DELIVRE (state, message) {
      // state.statusMessage = message.messageChat
      // state.lastMessage = message.messageChat
    },

    // --------------------------------------------------------------------
    // Message socialnetwork lu
    // --------------------------------------------------------------------
    SOCKET_UPDATE_CHAT_SOCIAL_LU (state, message) {
      state.statusMessage = message.messageChat
      // state.lastMessage = message.messageChat
    },

    // --------------------------------------------------------------------
    // Istyping dans la bulle chat
    // --------------------------------------------------------------------
    SOCKET_UPDATE_TYPING (state, message) {
      // console.log('SOCKET_UPDATE_TYPING')
      if (message.messageAction === 'updateTyping') {
        // uniquement pour ses evenements websocket
        // affiche uniquement le istyping du visiteur pas ce que j'envois
        if (
          (message.messageChat.auteur === 'Agent' &&
            message.messageChat.WZAgentId !== this.getters['_User/user'].id) ||
          message.messageChat.auteur === 'Visiteur'
        ) {
          var index = _.findIndex(state.listeAllVisiteurs, {
            visiteurID: message.messageChat.chatSession
          })
          if (index !== -1) {
            let nameAuteur = 'undefined'
            if (
              message.messageChat.nameAuteur &&
              message.messageChat.auteur === 'Agent'
            ) {
              // pour les agents
              nameAuteur = message.messageChat.nameAuteur
            } else if (state.listeAllVisiteurs[index].visiteurName) {
              // pour les visiteur
              nameAuteur = state.listeAllVisiteurs[index].visiteurName
            } else {
              nameAuteur = state.listeAllVisiteurs[index].visiteurID
            }
            // state.isTyping = message.messageChat
            // si on affiche le istyping
            if (message.messageChat.etat) {
              var indexTyping = _.findIndex(
                state.listeAllVisiteurs[index].histoChat,
                { isTyping: true, auteur: 'Visiteur' }
              )
              if (indexTyping !== -1) {
                state.listeAllVisiteurs[index].histoChat[indexTyping].message =
                  message.messageChat.message
              } else {
                let newMessage = {
                  isTyping: true,
                  auteur: message.messageChat.auteur,
                  message: message.messageChat.message,
                  nameAuteur: nameAuteur,
                  type: '1',
                  timestamp: new Date().getMilliseconds(),
                  visitorId: message.messageChat.chatSession,
                  agentId: message.messageChat.WZAgentId
                }
                // ajoute le istyping
                state.listeAllVisiteurs[index].histoChat.push(newMessage)
              }
              // sinon on l'efface
            } else {
              // retrouve les messages istyping
              this.commit('_StoreWatcheeBox/SOCKET_REMOVE_TYPING', {
                chatSession: message.messageChat.chatSession
              })
              // _.forEach(state.listeAllVisiteurs[index].histoChat, (messageVisiteur, key) => {
              //   if (messageVisiteur.isTyping) {
              //     state.listeAllVisiteurs[index].histoChat.splice(key, 1) // efface les messages istyping
              //   }
              // })
            }
          }
        }
      }
    },

    // --------------------------------------------------------------------
    // retir tous les isTyping
    // --------------------------------------------------------------------
    SOCKET_REMOVE_TYPING (state, message) {
      // console.log('SOCKET_REMOVE_TYPING state', state)
      // console.log('SOCKET_REMOVE_TYPING message', message)
      var index = _.findIndex(state.listeAllVisiteurs, {
        visiteurID: message.chatSession
      })
      if (index === -1) return
      // retrouve les messages istyping
      console.log('histoChat', state.listeAllVisiteurs[index].histoChat)
      for (let i = state.listeAllVisiteurs[index].histoChat.length - 1; i >= 0; i--) {
        const messageVisiteur = state.listeAllVisiteurs[index].histoChat[i]
        if (messageVisiteur && messageVisiteur.isTyping) {
          state.listeAllVisiteurs[index].histoChat.splice(i, 1)
        }
      }
    },

    // --------------------------------------------------------------------
    // Le client à repondu au questionnaire de satisfaction
    // --------------------------------------------------------------------
    SOCKET_RETOUR_SATISFACTION (state, message) {
      state.clientSatisfaction = message.messageChat
    },

// à finir plus trad
    // ----------------------------------------------------------------------------
    // Check la dispo d'agent avant transfere
    // ----------------------------------------------------------------------------
    CHECK_DISPO_AGENT (state, message) {
      // visiblemet il n'y a plus d'activité sur ce chat
      // si conversation un juste chat entrant
      let sendFormeSatis = false
      let sendClotureChat = false
      // c'est une conversation (l'agent a repondu au moins 1 message),
      // on regarde dans les cookies si il faut le formulaire et la cloture de chat
      // sinon on ferme uniquement le chat sans formulaire ni cloture
      if (message.datasVisiteur.chatted) {
        sendFormeSatis = new Vue().$cookie.get('wz-satisfaction-survey') === 'true' || false
        sendClotureChat = new Vue().$cookie.get('wz-closing-chat') === 'true' || false // on ferme
      }
      console.log('sendFormeSatis', sendFormeSatis)
      console.log('sendClotureChat', sendClotureChat)
      // check pour transfert uniquement :
      // - si pas en attente de reponse de transfert de chat
      // - si visiteur est encore en ligne
      // - si l'agent n'a pas encore ecrit au visite

      let listeAgentsAutorized = this.getters['_Sites/AUTORIZED_AGENTS']({
        agentsArray: state.agentsArray,
        siteID: message.datasVisiteur.siteID,
        myID: this.getters['_User/user'].id
      })
      console.log('listeAgentsAutorized', listeAgentsAutorized)
    },

    // --------------------------------------------------------------------
    // demande de prise en charge visiteur en attente
    // --------------------------------------------------------------------
    SOCKET_VISITOR_TRANSFERT (state, message) {
      // si c'est une demande de transfert
      if (message.emission) {
        state.transfertStatusEmission = {
          status: message.status,
          datas: message.messageDatas
        }
        // trouve les data du bon visiteur
        let indexVisiteur = _.findIndex(state.listeAllVisiteurs,
          {'visiteurID': message.messageDatas.chatSession}
        )
        // si c'est un transfert accepté
        if (message.status === 'ok') {
          // console.log('router', router)
          if (indexVisiteur === -1) return
          // on ferme le chat transferé sans le cloturer ni envoyer un formulaire de satisfaction
          this.dispatch('_StoreWatcheeBox/ACTION_CLOSE_CHAT', {
            formulaireSatisfaction: false,
            clotureChat: false,
            datasVisiteur: state.listeAllVisiteurs[indexVisiteur],
            message: '',
            fullPath: router.history.current.fullPath
          })
        } else if (message.status === 'no') {
// a finir avec la fonctin 'CHECK_DISPO_AGENT'
          // this.commit('_StoreWatcheeBox/CHECK_DISPO_AGENT', {
          //   datasVisiteur: state.listeAllVisiteurs[indexVisiteur]
          // })
        }
      // si c'est une reponse d'une demande de transfert
      } else {
        state.transfertStatusReception = {
          status: message.status,
          datas: message.messageDatas
        }
      }

      // si pas focus sur le BO envois d'une notif browser
      if (!state.focusPupitre.myFocus && message.status === 'transfere') {
        Push.create('Prise en charge Visiteur', {
          body: message.messageDatas.msg,
          tag: message.messageDatas.WZAgentId,
          icon: {
            x16: AWSS3_STATIC + '/img/logo/logo_16.png',
            x32: AWSS3_STATIC + '/img/logo/logo_32.png'
          },
          requireInteraction: true,
          onClick: function () {
            window.focus() // redonne le focus
            this.close() // ferme la bonne notification
            window.location =
              process.env.NODE_ENV === 'development'
                ? `${DOMAINE}/watcheezy/#/trafic/chatting`
                : `${DOMAINE}/#/trafic/chatting`
          }
        }).catch(() => {})
      }
    },

    // --------------------------- GESTION DES SESSIONS CHAT PRIVÉES ------------------------------------
    // ---------------------------------------------------------------------------------
    // Ajoute une session privée
    // ---------------------------------------------------------------------------------
    ADD_PRIVATE_SESSION_CHAT (state, { session, visiteur }) {
      // console.log('ADD_PRIVATE_SESSION_CHAT', session)
      // avant d'ajouter cette session il faut verifier qu'il n'y a pas deja cette session stoker
      let indexSession = _.findIndex(state.sessionsPrivees, [1, session[1]])
      if (indexSession === -1) {
        // nouvelle session a ajouter
        state.sessionsPrivees.push(session)
      } else {
        // cette session est deja présente, a modifier
        state.sessionsPrivees.splice(indexSession, 1, session)
      }
      // envois au serveur de chat la mise à jours des sessions chats de l'agent
      _watcheebox.updateSessionsChats({
        // 'socket': this.$socket,
        datasAgent: this.getters['_User/user'],
        sessionsPrivees: state.sessionsPrivees
      })
      // ----------------------------------------------------------------
      // enregistre ce nouveau chat en base
      // console.log(message)
      let dataToPost = new window.FormData()
      dataToPost.append('timestamp', Date.now())
      dataToPost.append('agent_id', this.getters['_User/user'].id)
      dataToPost.append('visiteur_id', visiteur.visiteurID)
      dataToPost.append('placePupitre', visiteur.placePupitre)
      dataToPost.append('status', 1)
      dataToPost.append('numChat', state.sessionsPrivees.length)
      dataToPost.append('chatMax', this.getters['_User/user'].chatsMax)
      axios.post('post/addChatPupitre.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        console.log('chat in pupitre', response)
      })
    },

    // ---------------------------------------------------------------------------------
    // Modification des données d'une session privée
    // ---------------------------------------------------------------------------------
    UPDATE_PRIVATE_SESSION_CHAT (state, { session, index }) {
      state.sessionsPrivees.splice(index, 1, session)
    },

    // ---------------------------------------------------------------------------------
    // Check les session privées actives
    // et mise à jour si necessaire
    // ---------------------------------------------------------------------------------
    CHECK_PRIVATE_SESSION_CHAT (state) {
      _.forEach(state.sessionsPrivees, (sessionChat, key) => {
        var indexVisiteur = _.findIndex(state.listeAllVisiteurs, {
          visiteurID: sessionChat[1]
        })
        if (indexVisiteur !== -1) {
          console.log('visteur en session chat :')
          console.log(state.listeAllVisiteurs[indexVisiteur].placePupitre)
          if (
            state.listeAllVisiteurs[indexVisiteur].fileAttente !== null ||
            state.listeAllVisiteurs[indexVisiteur].placePupitre !== null
          ) {
            // mise à jours de la session
            this.commit('_StoreWatcheeBox/UPDATE_PRIVATE_SESSION_CHAT', {
              session: sessionChat,
              index: key
            })
            // connect l'agent à la room client
            _watcheebox.clientConnectRoom({
              roomName: 'chat_' + sessionChat[1]
            })
          } else {
            // ce visiteur n'est visiblement plus en chat avec moi
            // j'efface la session
            state.sessionsPrivees.splice(key, 1)
          }
        } else {
          // pas de visiteur correspondant à la session chat
          // j'efface la session
          state.sessionsPrivees.splice(key, 1)
        }
      })
      // envois au serveur de chat la mise à jours des sessions chats de l'agent
      _watcheebox.updateSessionsChats({
        // 'socket': this.$socket,
        datasAgent: this.getters['_User/user'],
        sessionsPrivees: state.sessionsPrivees
      })
    },

    // ---------------------------------------------------------------------------------
    // Quand on ferme un chat,
    // il faut retirer le visiteur de la session chat privée
    // ---------------------------------------------------------------------------------
    // REMOVE_ALL_CHATS_SESSION (state) {
    //   console.log('REMOVE_ALL_CHATS_SESSION')

    //   // Étape 1 : mettre l’agent en offline AVANT de tuer la session
    //   let dataToPost = new window.FormData()
    //   dataToPost.append('agent_id', this.getters['_User/user'].id)
    //   dataToPost.append('status', 'offline')

    //   axios.post('post/addStatusAgent.php', dataToPost, {
    //     headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    //   })
    //   .then(response => {
    //     if (response.status === 200) {
    //       console.log('Status agent enregistré', response.statusText)
    //     }
    //   })
    //   .catch(err => {
    //     console.log('Erreur status agent', err)
    //   })

    //   let sessionNum = state.sessionsPrivees.length
    //   let num = 0

    //   if (!sessionNum) {
    //     // 👉 Pas de chat en cours → on peut logout directement
    //     this.doLogout(state)
    //   } else {
    //     state.sessionsPrivees.forEach((session, key) => {
    //       let i = state.listeAllVisiteurs.findIndex(
    //         visiteur => visiteur.visiteurID === session[1]
    //       )
    //       if (i !== -1) {
    //         let dataToPost2 = new window.FormData()
    //         dataToPost2.append('timestamp', Date.now())
    //         dataToPost2.append('agent_id', this.getters['_User/user'].id)
    //         dataToPost2.append('visiteur_id', state.listeAllVisiteurs[i].visiteurID)
    //         dataToPost2.append('placePupitre', state.listeAllVisiteurs[i].placePupitre)
    //         dataToPost2.append('status', 0)
    //         dataToPost2.append('numChat', state.sessionsPrivees.length)
    //         dataToPost2.append('chatMax', this.getters['_User/user'].chatsMax)

    //         axios.post('post/addChatPupitre.php', dataToPost2, {
    //           headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    //         })
    //         .then(response => {
    //           num++
    //           if (num === sessionNum) {
    //             // 👉 une fois tous les chats fermés → logout
    //             this.doLogout(state)
    //           }
    //         })
    //         .catch(err => {
    //           console.log('Erreur addChatPupitre', err)
    //         })
    //       }
    //     })
    //   }
    // },

    /**
     * REMOVE_ALL_CHATS_SESSION
     * @description Nettoie les sessions privées et la liste des visiteurs
     * @param {Object} state - Le state à modifier
     * @since 20.01.2020
     */
    REMOVE_ALL_CHATS_SESSION (state) {
      console.log('REMOVE_ALL_CHATS_SESSION (mutation) → nettoyage local')
      state.sessionsPrivees = []
      state.listeAllVisiteurs = []
    },

    // ---------------------------------------------------------------------------------
    // Quand on ferme un chat,
    // il faut retirer le visiteur de la session chat privée
    // ---------------------------------------------------------------------------------
    REMOVE_PRIVATE_SESSION_CHAT (state, data) {
      // s'applique à tous sauf les messages en attentes
      if (router.app._route.name !== 'attente') {
        console.log('REMOVE_PRIVATE_SESSION_CHAT', data)
        if (data.index !== -1) {
          state.sessionsPrivees.splice(data.index, 1)
        }

        let dataToPost2 = new window.FormData()
        dataToPost2.append('timestamp', Date.now())
        dataToPost2.append('agent_id', this.getters['_User/user'].id)
        dataToPost2.append('visiteur_id', data.visiteurID)
        dataToPost2.append('placePupitre', data.placePupitre)
        dataToPost2.append('status', 0)
        dataToPost2.append('numChat', state.sessionsPrivees.length)
        dataToPost2.append('chatMax', this.getters['_User/user'].chatsMax)
        axios.post('post/addChatPupitre.php', dataToPost2, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then(response => {
          console.log('chat out pupitre', response)
        })
        .catch()
        .then(_ => {
          // this.loading = false
        })

        // mise à jour des infos visiteur dans le store
        var indexVisiteur = _.findIndex(state.listeAllVisiteurs, {
          visiteurID: data.visiteurID
        })
        if (indexVisiteur !== -1) {
          state.listeAllVisiteurs[indexVisiteur].fileAttente = null
          state.listeAllVisiteurs[indexVisiteur].lastMessage = null
          state.listeAllVisiteurs[indexVisiteur].placePupitre = null
          state.listeAllVisiteurs[indexVisiteur].timeStampArrive = null
        }

        // mise à jour des sessions chats dans redis
        let arrayVisiteur = {}
        arrayVisiteur.visiteurID = data.visiteurID
        _watcheebox.totalConversations({
          datasAgent: this.getters['_User/user'],
          agentSocketID: state.mySocketID,
          arrayVisiteur: arrayVisiteur,
          sessionsPrivees: state.sessionsPrivees,
          status: 'moins'
        })

        // deconnexion de l'agent de la room visiteur
        _watcheebox.clientQuitRoom({ roomName: 'chat_' + data.visiteurID })

        // il faut regarder si le visiteur qu'on ferme etait sur le pupitre
        // et si oui il faut regarder si il n'y a pas un  visiteur en file d'attente
        // qui peut prendre ca place
        var index = _.findIndex(state.listeAllVisiteurs, {
          visiteurID: data.visiteurID
        })
        if (index !== -1) {
          // si ce visiteur etait en file d'attente avec moi
          if (
            state.listeAllVisiteurs[index].fileAttente ===
            this.getters['_User/user'].id
          ) {
            // pour le moment je ne fais rien
          } else {
            // si ce visiteur etait sur le pupitre
            // nouvelle place pupitre disponible
            if (data.placePupitre) {
              let newArrayVisiteurAttente = []
              // regarde si un  autre visiteur est en file d'attente
              _.forEach(state.listeAllVisiteurs, (visiteur, key) => {
                if (visiteur.fileAttente === this.getters['_User/user'].id) {
                  newArrayVisiteurAttente.push(visiteur)
                }
              })

              // si il y a des visiteus en liste d'attente
              if (newArrayVisiteurAttente.length) {
                // class par temps d'attente
                newArrayVisiteurAttente = _.orderBy(
                  newArrayVisiteurAttente,
                  ['timeStampArrive'],
                  ['asc']
                )
                // le premier de la liste
                var indexVisiteurAttente = _.findIndex(state.listeAllVisiteurs, {
                  visiteurID: newArrayVisiteurAttente[0].visiteurID
                })
                state.listeAllVisiteurs[indexVisiteurAttente].fileAttente = null
                state.listeAllVisiteurs[indexVisiteurAttente].placePupitre =
                  data.placePupitre
                // j'efface sont historique pour être sur de le recharger dans le pupitre
                state.listeAllVisiteurs[indexVisiteurAttente].histoChat = []
              }
            }
          }

          // Si c'est un visiteur qui arrive d'un reseau social on le retire de listeAllVisiteur
          if (state.listeAllVisiteurs[index].network) {
            // supprime ce visiteur car il n'est pas geré par nodejs moon
            state.listeAllVisiteurs.splice(index, 1)
          }
        }
        this.dispatch('_Notifier/NEW_NOTIF', { message: data.message, context: 'info' })
      }
    },

    // ---------------------------------------------------------------------------------
    // Efface toutes les sessions privées
    // ---------------------------------------------------------------------------------
    CLEAR_PRIVATE_SESSION_CHAT (state) {
      state.sessionsPrivees = []
    },
    // --------------------------- FIN GESTION DES SESSIONS CHAT PRIVÉES ------------------------------------

    // ---------------------------------------------------------------------------------
    // clear la fenetre message en attente
    // ---------------------------------------------------------------------------------
    CLEAR_MESSAGE_ATTENTE (state) {
      state.messageAttenteSelected = {}
    },
    // ---------------------------------------------------------------------------------
    // clear la fenetre message dans contact
    // ---------------------------------------------------------------------------------
    CLEAR_CONTACT_OPEN (state) {
      state.contactSelected = {}
    },
    // CHAT OUVERT DANS VISITEUR
    VISITEUR_ADD_CHAT (state, { sessionID, dataVisiteur }) {
      console.log('VISITEUR_ADD_CHAT', dataVisiteur)
      console.log('router', router.app._route.name)
      // pour les message en attentes
      if (router.app._route.name === 'attente') {
        console.log('open chat')
        state.messageAttenteSelected = {'visiteurID': dataVisiteur.visiteurID, 'timestampMessage': dataVisiteur.timestamp, 'network': dataVisiteur.network}
        state.contactSelected = {} // efface le contact
      } else if (router.app._route.name === 'contact') {
        state.contactSelected = {'visiteurID': dataVisiteur.visiteurID, 'timestampMessage': dataVisiteur.timestamp, 'network': dataVisiteur.network}
        state.messageAttenteSelected = {} // efface dans les message en attente
      } else {
        // pour les chat en live
        state.visiteurChatSelected = sessionID
      }
      // efface le dernier message envoyé car le chat est ouvert
      var index = _.findIndex(state.listeAllVisiteurs, {
        visiteurID: sessionID
      })
      if (index === -1) return
      state.listeAllVisiteurs[index].lastMessage = ''
    },

    VISITEUR_REMOVE_CHAT (state) {
      console.log('VISITEUR_REMOVE_CHAT', state)
      // state.visiteurChatSelected = null
      // pour les message en attentes
      if (router.app._route.name === 'attente') {
        state.messageAttenteSelected = {}
        // il faut effacer le directChat du sessionStorage même si il n'y à riens dedans
        sessionStorage.removeItem('tf-directChat')
        router.push({path: '/trafic/attente/'})
      } else if (router.app._route.name === 'contact') {
        state.contactSelected = {}
      } else {
        // pour les chat en live
        state.visiteurChatSelected = null
      }
    },

    SET_STATUS (state, status) {
      if (['online', 'offline', 'busy'].indexOf(status) !== -1) {
        state.status = status
      }
    },

    SET_SESSION_PHP (state, value) {
      state.sessionPHP = value
    },

    /**
     * Modifie le status de l'agent changé par l'agent
     */
    SET_STATUS_MANUALLY (state, status) {
      if (['online', 'offline', 'busy'].indexOf(status) !== -1) {
        state.statusManually = status
      }
    },

    SOCKET_RETURN_GEOLOC (state, data) {
      if (data.position.error !== '0') {
        // pour l'object visiteurs
        var index = _.findIndex(state.listeAllVisiteurs, {
          visiteurID: data.position.chatSession
        })
        if (index === -1) return
        var visiteurSelect = _.cloneDeep(state.listeAllVisiteurs[index])
        visiteurSelect.geoloc = {
          erreur: data.position.error,
          message: data.position.errorMessage
        }
        state.listeAllVisiteurs.splice(index, 1, visiteurSelect)
      } else {
        // pour l'object visiteurs
        var index2 = _.findIndex(state.listeAllVisiteurs, {
          visiteurID: data.position.chatSession
        })
        if (index2 === -1) return
        var visiteurSelect2 = _.cloneDeep(state.listeAllVisiteurs[index2])
        visiteurSelect2.geoloc = {
          erreur: data.position.error,
          latitude: data.position.latitude,
          longitude: data.position.longitude,
          altitude: data.position.altitude,
          vitesse: data.position.vitesse
        }
        state.listeAllVisiteurs.splice(index2, 1, visiteurSelect2)
      }
    },

    // ---------------------------------------------------------------------------------
    // Retour de la réponse du visiteur à la demande de cobrowsing
    // ---------------------------------------------------------------------------------
    SOCKET_RETURN_REPONSE_COBROWSING (state, data) {
      console.log('SOCKET_RETURN_REPONSE_COBROWSING', data.data)
      var visiteur = _.findIndex(state.listeAllVisiteurs, {
        placePupitre: data.data.placePupitre
      })
      if (visiteur !== -1) {
        var visiteurSelect = _.cloneDeep(state.listeAllVisiteurs[visiteur])
        visiteurSelect.reponseCobrowsing = data.data.reponse
        state.listeAllVisiteurs.splice(visiteur, 1, visiteurSelect)
      } else {

      }
      // var indexPupitre = (data.data.placePupitre - 1)
      // if (data.data.reponse) {
      //   state.demandeCobrowsing = {'reponse': 'ok', 'placePupitre': data.data.placePupitre}
      //   state.cobrowsingActif[indexPupitre] = true // le cobrowsing est actif
      // } else {
      //   state.demandeCobrowsing = {'reponse': 'no', 'placePupitre': data.data.placePupitre}
      //   state.cobrowsingActif[indexPupitre] = false // le cobrowsing est inactif
      // }
    },

    // -------------------------------------------------------------
    // COBROWSING ACTIIF/INACTIF
    // si inactif c'est du mirroring
    // -------------------------------------------------------------
    SET_STATUS_COBROWSING (state, data) {
      var indexPupitre = data.placePupitre - 1
      state.cobrowsingActif[indexPupitre] = data.status
    },

    // -------------------------------------------------------------
    // timerInactifAgent ACTIIF/INACTIF
    // stocker les timers d'inactivité de l'agent
    // -------------------------------------------------------------
    SET_STATUS_TIMERINACTIFAGENT (state, data) {
      console.log('SET_STATUS_TIMERINACTIFAGENT', data)
      var indexPupitre = data.placePupitre - 1
      // si c'est le premier timer, au mounted du chat
      // et si il y a deja un timer en place, on continu de l'utiliser pour ne pas le remettre a 0
      // if (data.mounted) {
      //   console.log('state.timerActifAgent[indexPupitre]', state.timerActifAgent[indexPupitre])
      //   if (!state.timerActifAgent[indexPupitre]) {
      //     console.log('mounted sans timer')
      //     state.timerActifAgent[indexPupitre] = data.timerAgent
      //   }
      // } else {
      //   // si il y a deja un timer en place
      //   if (!data.timerAgent) {
      //     console.log('efface timer')
      //     clearTimeout(state.timerActifAgent[indexPupitre]) // on le kill
      //   } else {
      //     console.log('ajoute timer')
      //     clearTimeout(state.timerActifAgent[indexPupitre]) // on le kill
      //     state.timerActifAgent[indexPupitre] = data.timerAgent
      //   }
      // }
      // si il y a deja un timer en place
      if (!data.timerAgent) {
        // console.log('efface timer')
        clearTimeout(state.timerActifAgent[indexPupitre]) // on le kill
      } else {
        // console.log('ajoute timer')
        // clearTimeout(state.timerActifAgent[indexPupitre]) // on le kill
        state.timerActifAgent[indexPupitre] = data.timerAgent
      }
    },

    /**
     * Change la valeur afin de savoir si le nombre d'agents max
     * a déjà été checké durant la session de l'agent
     * @param {Object} state
     * @param {Boolean} value nouvelle valeur
     */
    SET_TOO_MUCH_AGENTS_CHECKED (state, value) {
      state.tooMuchAgentsChecked = value
    },

    // -------------------------------------------------------------
    // DEBLOQUAGE MULTISESSION
    // retour du serveur pour indiquer à l'agent que le multisession est debloqué
    // -------------------------------------------------------------
    SOCKET_DEBLOQUE_MULTISESSION (state, data) {
      console.log('multisession debloqué', data)
      let user = this.getters['_User/user']
      // user.status = this.status // sinon on garde le status actuel
      // si il a des cles webPush
      let storageKeyWebPush = window.localStorage.getItem('server-keys')
      let storageSubscriptionWebPush = window.localStorage.getItem('server-subscription')
      _watcheebox.connexionAgent({
        // 'socket': this.$socket,
        datasAgent: user, // les données agent
        agentName: user.fname + ' ' + user.lname, // sont nom
        sessionPHP: state.sessionPHP, // sa sessionPHP
        sid: new Vue().$cookie.get('NODE-SID'), // id server nodejs
        keyWebPush: storageKeyWebPush,
        subscriptionWebPush: storageSubscriptionWebPush
      })
    },

    // -------------------------------------------------------------
    // EFFACE DES CONTACTS
    // -------------------------------------------------------------
    SET_DEL_CONTACT_RESEAU: (state, data) => {
      console.log('SET_DEL_CONTACT_RESEAU', data)
      // remplace la liste des contact par la nouvelle liste à jour
      // state.listeContactReseaux = data.liste
      let index = _.findIndex(state.listeContactReseaux, function (o) { return o.userId === data.userId })
      if (index !== -1) {
        state.listeContactReseaux.splice(index, 1)
      } else {
        // console.log('pas de contact')
      }
    },

    // -------------------------------------------------------------
    // AJOUTE UN MESSAGES DANS HISTORIQUE CONTACT OUVERT
    // -------------------------------------------------------------
    SET_ADD_MESSAGE_CONTACT (state, data) {
      console.log('SET_ADD_MESSAGE_CONTACT', data.messageChat)
      // si un contact est ouvert
      if (Object.keys(state.contactSelected).length) {
        // let messagesList = state.listeMessages
        let newMessageContact
        // si c'est un message facebook
        if (data.messageChat.network === 'facebook') {
          newMessageContact = {
            'chatSession': '0',
            'agentId': Number.parseInt(data.messageChat.agentID),
            'auteur': data.messageChat.auteur,
            'attachments': data.messageChat.attachments,
            'message': data.messageChat.message,
            'nameAuteur': data.messageChat.dataVisiteur.first_name + ' ' + data.messageChat.dataVisiteur.last_name,
            'timestamp': Math.floor(data.messageChat.time / 1000),
            'type': '1',
            'visiteurID': data.messageChat.senderID
          }
          // si c'est un message whatsapp
        } else if (data.messageChat.network === 'whatsapp') {
          newMessageContact = {
            'chatSession': '0',
            'agentId': Number.parseInt(data.messageChat.agentID),
            'auteur': data.messageChat.auteur,
            'attachments': data.messageChat.attachments,
            'message': data.messageChat.message,
            'nameAuteur': data.messageChat.nameAuteur,
            'timestamp': Math.floor(data.messageChat.time / 1000),
            'type': '1',
            'visiteurID': data.messageChat.senderID
          }
          // messages sur le network moon ou autre
        } else {
          // il manque le messageId si je recupère directement les données du message
          newMessageContact = {
            'chatSession': '0',
            'agentId': Number.parseInt(data.messageChat.agentID),
            'auteur': data.messageChat.auteur,
            'attachments': data.messageChat.attachments,
            'message': data.messageChat.message,
            'nameAuteur': data.messageChat.chatSession,
            'timestamp': Math.floor(data.messageChat.time / 1000),
            'type': '1',
            'visiteurID': data.messageChat.chatSession
          }
        }
        console.log('newMessageContact', newMessageContact)
        // ajoute ce massegae dans l'historique de chat du contact ouvert
        state.contactOpened.histoChat.push(newMessageContact)
      }
    }
  },

  actions: {
    startSocketReconnectLoop ({ state, commit }, socket) {
      if (state.isTryingReconnect) return  // ⛔ empêcher double boucle
      commit('START_RECONNECT_LOOP')
      const timer = setInterval(() => {
        if (!socket.connected) {
          console.log('🔄 Tentative automatique de reconnexion…')
          socket.connect()
        } else {
          console.log('🟢 Reconnecté → arrêt de la boucle')
          commit('STOP_RECONNECT_LOOP')
        }
      }, 3000)
      commit('SET_RECONNECT_TIMER', timer)
    },

    stopSocketReconnectLoop ({ commit }) {
      commit('STOP_RECONNECT_LOOP')
    },
    /**
     * charge les contact entreprise reseaux sociaux au login agent
     */
    ACTION_GET_ALL_CONTACT_RESEAUX: (context, entrepriseID) => {
      // console.log('ACTION_GET_ALL_CONTACT_RESEAUX', entrepriseID)
      // passe à la requete
      axios.get(
        'get/chats_allContact.php?entrepriseId=' +
        entrepriseID
      )
      .then(response => {
        // console.log('response', response)
        context.commit('SET_LIST_CONTACT_RESEAUX', {
          'listeContact': response.data,
          'entrepriseId': entrepriseID
        })
        return new Promise((resolve, reject) => {
          resolve(response)
        })
      })
      .catch(_ => {
        // window.alert('totejfojiz ezuihf uihezhf uihs of uge')
      })
      .then(_ => {
      })
    },

    /**
     * l'agent ferme du messaging, il n'est pas necessaire d'afficher une dialogueBox
     */
    ACTION_CLOSE_MESSAGING: (context, payload) => {
      // console.log('fermeture du chat dans attente', payload)
      var txtSnackBar = `${i18n.t('endOfConversation')} (${i18n.tc('visitors', 1, {count: ''})} ${payload.datasVisiteur.visiteurID})`
      context.commit('AGENT_FOCUS', {
        'view': 1,
        'visiteurID': 1
      })
      // efface toutes les données du visiteur ouvert
      if (router.app._route.name === 'attente') {
        context.commit('SET_VISITEURS_ALL_DATA_MESSAGE_ATTENTE', {})
        if (context.state.visiteurChatSelected === payload.datasVisiteur.visiteurID || context.state.messageAttenteSelected.visiteurID === payload.datasVisiteur.visiteurID) {
          context.commit('VISITEUR_REMOVE_CHAT')
        }
        // redirige vers le bon chemin
        // if (router.app._route.name === 'attenteOpenchat') {
        //   router.push({ path: '/trafic/attente' })
        // }
      } else if (router.app._route.name === 'contact') {
        context.commit('SET_CONTACT_ALL_DATA', {})
        // console.log('context.state.visiteurChatSelected', context.state.visiteurChatSelected)
        // console.log('payload.datasVisiteur', payload.datasVisiteur)
        if (context.state.visiteurChatSelected === payload.datasVisiteur.visiteurID || context.state.contactSelected.visiteurID === payload.datasVisiteur.visiteurID) {
          context.commit('VISITEUR_REMOVE_CHAT')
        }
      }
      let placeDispo = payload.datasVisiteur.placePupitre
      // Remove la session privée
      var indexSession = _.findIndex(context.state.sessionsPrivees, [1, payload.datasVisiteur.visiteurID])
      context.commit('REMOVE_PRIVATE_SESSION_CHAT', {
        index: indexSession,
        visiteurID: payload.datasVisiteur.visiteurID,
        placePupitre: placeDispo,
        message: payload.textNotif || txtSnackBar
      })
    },

    /**
     * l'agent ferme le chat
     */
    ACTION_CLOSE_CHAT: (context, payload) => {
      // console.log('payload', payload)
      // console.log('context.state.sessionsPrivees 2', context.state.sessionsPrivees.length)
      // t.messages[t.locale][to.path.split('/')[1]] || to.path.split('/')[1]
      // si option envois formulaire de satisfaction est TRUE
      var txtSnackBar = `${i18n.t('endOfConversation')} (${i18n.tc('visitors', 1, {count: ''})} ${payload.datasVisiteur.visiteurID})`
      let user = context.rootState._User
      // console.log('user', user)
      // console.log('context', context)
      let config = {
        responseType: 'json',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/x-www-form-urlencoded' }
      }
      if (payload.formulaireSatisfaction) {
        // Connexion de l'agent
        _watcheebox.sendFormSatisfaction({
          // 'socket': i18n.socket,
          agentSocketID: context.state.mySocketID,
          datasAgent: user,
          datasVisiteur: payload.datasVisiteur,
          message: 'test satis',
          messageType: '4',
          agentName: unescape(context.rootGetters['_User.fullName'])
        })

        // contenu de la snackBar
        txtSnackBar = `${i18n.t('satisfactionFormSent')} (${i18n.tc('visitors', 1, {count: ''})} ${payload.datasVisiteur.visiteurID})`
      } else {
        if (payload.message) {
          // console.log('il y a un message à envoyer', payload.message)
          // Connexion de l'agent
          _watcheebox.envoisMessage({
            // 'socket': this.$socket,
            agentSocketID: context.state.mySocketID,
            datasAgent: user,
            datasVisiteur: payload.datasVisiteur,
            message: payload.message,
            attachments: '',
            messageType: 7,
            agentName: unescape(context.rootGetters['_User.fullName'])
          })
        }
      }

      // si je cloture cette discussion je doit marquer tous les message chat avec un id session
      if (payload.clotureChat) {
        // ##############################
        // Evois en POST
        // ##############################
        let dataToPost = new window.FormData()
        dataToPost.append('agentID', user.id)
        dataToPost.append('entID', user.entId)
        dataToPost.append('visiteurID', payload.datasVisiteur.visiteurID)
        dataToPost.append('chatSessionID', payload.datasVisiteur.visiteurID + Date.now())

        axios
          .post('post/clotureChat.php', dataToPost, config)

          .then(response => {
            // contenu de la snackBar
            txtSnackBar = `${i18n.t('endOfConversation')} (${i18n.tc('visitors', 1, {count: ''})} ${payload.datasVisiteur.visiteurID})`
          })
          .catch()
          .then(_ => {
          })
      }
      // si dans la section message en chatting
      if (payload.fullPath === '/trafic/chatting') {
        // console.log('fermeture du chat dans chatting')
        // focus sur un ancien visiteur du pupitre si il y en a encore dessus
        let newIndexFocusPupitre = _.findIndex(context.state.listeAllVisiteurs, (o) => {
          if (o.placePupitre && o.placePupitre !== payload.datasVisiteur.placePupitre) {
            return o.placePupitre
          }
        })
        // console.log('newIndexFocusPupitre', newIndexFocusPupitre)
        if (newIndexFocusPupitre !== -1) {
          context.commit('AGENT_FOCUS', {
            'view': context.state.listeAllVisiteurs[newIndexFocusPupitre].placePupitre,
            'visiteurID': context.state.listeAllVisiteurs[newIndexFocusPupitre].visiteurID
          })
        } else {
          context.commit('AGENT_FOCUS', {
            'view': 1,
            'visiteurID': 1
          })
        }
      // si dans la section message en attente
      } else if (payload.fullPath === '/trafic/attente') {
        // console.log('fermeture du chat dans attente')
        context.commit('AGENT_FOCUS', {
          'view': 1,
          'visiteurID': 1
        })
        // efface toutes les données du visiteur ouvert
        context.commit('SET_VISITEURS_ALL_DATA_MESSAGE_ATTENTE', {})
      } else {
        context.commit('AGENT_FOCUS', {
          'view': 1,
          'visiteurID': 1
        })
        // console.log('fermeture du chat dans visiteur')
      }
      // si ce visiteur est aussi ouvert dans "visiteurs" et uniquement si on est pas dans la section 'attente'
      // alors on le ferme dans les 2 sections "visiteurs et "discussions
      if (context.state.visiteurChatSelected === payload.datasVisiteur.visiteurID || context.state.messageAttenteSelected.visiteurID === payload.datasVisiteur.visiteurID) {
        context.commit('VISITEUR_REMOVE_CHAT')
      }
      // indique dans le store que la fiche visiteur est fermé, ne s'applique pas a la section "attente"
      // si dans la section message en attente
      if (payload.fullPath !== '/trafic/attente') {
        context.commit('CLOSE_FICHE_VISITEUR', payload.datasVisiteur)
      }
      let placeDispo = payload.datasVisiteur.placePupitre
      // Remove la session privée
      var indexSession = _.findIndex(context.state.sessionsPrivees, [1, payload.datasVisiteur.visiteurID])
      context.commit('REMOVE_PRIVATE_SESSION_CHAT', {
        index: indexSession,
        visiteurID: payload.datasVisiteur.visiteurID,
        placePupitre: placeDispo,
        message: payload.textNotif || txtSnackBar
      })
      // enregistre la date du dernier message envoyé
      var last = payload.datasVisiteur.histoChat.length ? payload.datasVisiteur.histoChat.length - 1 : 0
      var timeLastMessage = last ? payload.datasVisiteur.histoChat[last].timestamp : ''
      // ##############################
      // Evois en POST
      // ##############################
      let dataToPost = new window.FormData()
      dataToPost.append('timestamp', timeLastMessage)
      dataToPost.append('visiteurID', payload.datasVisiteur.visiteurID)

      axios.post('post/timeLastMessage.php', dataToPost, config)

      .then(response => {
        console.log(response)
      })
      .catch()
      .then(_ => {
        // this.loading = false
      })
    },
    async removeAllChatsSession ({ state, rootGetters, commit }, socket) {
      try {
        console.log('ACTION removeAllChatsSession appelée')
        let agentId = rootGetters['_User/user'].id
        _watcheebox.changeStatusAgent(
          {
            'statut': 'offline',
            'agentID': agentId,
            'sessionsPrivees': [],
            'roomName': rootGetters['_User/user'].entKey,
            'socket': socket,
            'sessionPHP': 'null'
          }
        )
        // 1. statut offline
        // let dataToPost = new FormData()
        // dataToPost.append('agent_id', agentId)
        // dataToPost.append('status', 'offline')

        // axios.post(
        //   'post/addStatusAgent.php',
        //   dataToPost,
        //   {
        //     withCredentials: true  // pour envoyer le cookie de session
        //     // pas besoin de forcer Content-Type !
        //   }
        // )
        // .then(response => {
        //   console.log('post/addStatusAgent.php OK', response)
        //   // router.push({ path: '/login' })
        // })
        // .catch(err => {
        //   console.error('Erreur addStatusAgent.php:', err.response.status, err.response.data)
        // })

        // 2. si aucune session → logout direct
        // if (!state.sessionsPrivees.length) {
        //   let res = await axios.post('post/logout.php')
        //   if (res.status === 200) {
        //     console.log('logout.php OK')
        //     commit('REMOVE_ALL_CHATS_SESSION') // reset local state
        //     // et logout user
        //     // this.dispatch('logoutBackEnd')
        //     await this.dispatch('logoutUser', socket, { root: true })
        //     // console.log('DASH :: pas de session php')hj
        //   }
        //   // return
        // }

        // 3. sinon → fermer toutes les sessions
        let promises = state.sessionsPrivees.map(session => {
          let visiteur = state.listeAllVisiteurs.find(v => v.visiteurID === session[1])
          if (!visiteur) return Promise.resolve()

          let dataToPost2 = new FormData()
          dataToPost2.append('timestamp', Date.now())
          dataToPost2.append('agent_id', agentId)
          dataToPost2.append('visiteur_id', visiteur.visiteurID)
          dataToPost2.append('placePupitre', visiteur.placePupitre)
          dataToPost2.append('status', 0)
          dataToPost2.append('numChat', state.sessionsPrivees.length)
          dataToPost2.append('chatMax', rootGetters['_User/user'].chatsMax)

          return axios.post('post/addChatPupitre.php', dataToPost2, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          })
        })

        await Promise.all(promises)
        console.log('Toutes les sessions ont été fermées')

        // logout après fermeture
        let res = await axios.post('post/logout.php')
        if (res.status === 200) {
          console.log('logout.php OK après fermeture des chats')
          // commit('REMOVE_ALL_CHATS_SESSION') // reset local state
          // et logout user
          await this.dispatch('logoutUser', socket)
          router.push({ path: '/login' })
        }
      } catch (err) {
        console.error('Erreur dans removeAllChatsSession:', err)
      }
    },
    ACTION_RELOAD_LOGIN: (context, payload) => {
      router.push({ path: '/login' })
    },
    connectSocket ({ commit }, socket) {
      console.log('ACTION connectSocket socket', socket)
      // const socket = this._vm.$socket  // on récupère le socket injecté par ton plugin
      // if (!socket.connected) {
      socket.connect()
      commit('SET_CONNECTED', true)
      // }
    },
    disconnectSocket ({ commit }) {
      const socket = this._vm.$socket
      if (socket.connected) {
        // socket.disconnect()
        // commit('SET_CONNECTED', false)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/storeWatcheeBox.js